import { Service, PAGEACTIVITY,ServiceTaggingDetail } from './../constants/actionType'
import { catchJSException, logOtherInfo, detailsInfo } from './logService'
import { getPDCforSC } from './apiService'
import { InHomeUtils } from './../util/inhomeUtils'
import { getCartProducts, getProductsFromCartArray } from './../util/sitecatalystUtility'
import { getCartHeader } from '../util/cartUtility'
import { store } from './../index';
import queryString from 'query-string';
import buildProduct from '../containers/buildProduct'
var vzdl = require('./vzdlData.json');
let serviceQualified = '';
let gProductArray = [];
const shaKey ='TWoOwIsECMenIFOunDR97WMounTAIns8anD2A3DiaMOndYbUR15dCunderHN0rtHKELop';
var isFirstCartAdd = true;
let subflowChange = '';
let accountHashed = '';
let isProdView = false;
let currProductsArray = [];
let movesDirectBuildProduct = true;
let pageDetailObj = {
    error : "Error Page",
    orderConfirmMhEligible : "order confirmation - mh eligible",
    orderConfirmMhEnrolled : "order confirmation - mh enrolled",
    orderConfirmMhNotEligible : "order confirmation - mh not eligible",
    orderConfirm : "order confirmation"
}
let targetMessageFlag = false;
let response = window.sessionStorage.getItem('comboResponseObj');
let responseObj = JSON.parse(response)
let sequentialFiosComboOrder = responseObj?.sequentialFiosComboOrder
console.log(responseObj,"responseObj", sequentialFiosComboOrder, "sequentialFiosComboOrder") // ITT-694287
let tempPageName = 'buildproducts'
if(window?.location?.pathname === '/inhome/streamlinetvvoice'){
    tempPageName = "Streamline Buildproducts - TV & Phone"
}
else if(window?.location?.pathname.indexOf('/inhome/streamlineordering') > -1){
    tempPageName = 'Streamline Buildproducts - Internet & Perks'
}
else{
    tempPageName = 'buildproducts'
}

export const getVZDLInit = (pageInfo, stateInfo, pageNameDetail = "") => {    
    let dtmdomainurl = window.location.href.toLowerCase();

    let flowName = dtmdomainurl.indexOf("/clu") !== -1 ? "" : (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo) && stateInfo.lqInfo.isoneLQFlow && pageInfo === "checkAvaillqInit") ? "prospect accord" : "prospect accord";
    let pagetype = -1 !== dtmdomainurl.indexOf("/clu") ? "learn" : (-1 !== dtmdomainurl.indexOf("/inhome") || -1 !== dtmdomainurl.indexOf("/local")) ? "order" : "learn";
    let pfxID = -1 !== dtmdomainurl.indexOf("/urc") ? "urc" : (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && InHomeUtils.isNotNull(stateInfo.appInfo.flowType) && stateInfo.appInfo.flowType === "SUPP") ? "whn" : "res";
    let lineOfBusiness = (-1 !== dtmdomainurl.indexOf("/urc") || (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && InHomeUtils.isNotNull(stateInfo.appInfo.flowType) && stateInfo.appInfo.flowType === "SUPP")) ? "myverizon" : "residential";
    let adobesuite = -1 !== dtmdomainurl.indexOf("/clu") ? (document.domain.indexOf("www.verizon.com") !== -1 ? "verizontelecomglobal,verizontelecomres" : "verizontelecomglobaldev,verizontelecomresdev") : (document.domain.indexOf("www.verizon.com") !== -1 ? "verizontelecomglobal,verizontelecomres" : "verizontelecomglobaldev,verizontelecomresdev");
    let isvzfwFlag =  stateInfo?.buildproductInfo?.isVZFwdFlag?true:false;
    const isVzfwdNyOffer =  stateInfo?.buildproductInfo?.isVzfNYDiscount;
    const lqResponse = JSON.parse(window.sessionStorage.getItem("LQResponse"))
    const isRoommateScenerio =  window?.sessionStorage?.enableRoommateScenerioOnOSI === "fios_roommate" && stateInfo?.appInfo?.flowType !== "SUPP" && stateInfo?.appInfo?.flowType !== "MV" && stateInfo?.lqInfo?.runtimeKey?.enableRoommateScenerioOnOSI === 'Y' && lqResponse?.data?.qualificationDetails?.data?.inService === 'Y' && stateInfo?.buildproductInfo?.roommateOptionSelected === "" && !stateInfo?.buildproductInfo?.roommateErrorCase;

    let isMnhEligible = stateInfo?.buildproductInfo?.internet?.mnhSignupIndicator!==undefined && stateInfo?.buildproductInfo?.internet?.mnhSignupIndicator!=="" && stateInfo?.buildproductInfo?.internet?.mnhSignupIndicator!=="N"?true:false;
    
    updateSaveCartEmail();
    updatePersonalInfo();
    if (dtmdomainurl.indexOf("/urc") !== -1) {
        adobesuite = document.domain.indexOf("www.verizon.com") !== -1 ? "verizontelecomglobal" : "verizontelecomglobaldev";
    }
    let initData = scVzdlDataDetails[pageInfo];
    if (initData == undefined && pageInfo === "connectionEligibility") {
        initData = Object.assign({}, {
            name: "affinity eligibility info",
            detail: "ultimate employees eligibility info",
            flowName: "prospect"
        })
    }
    
    if (initData == undefined && pageInfo === "popularplans") {
        initData = Object.assign({}, {
            name: "Popular Plans",
            flow: "broadband facts fios"      }) 
    }
    if (initData == undefined && pageInfo === "fccbroadbandlabelsinit") {
        initData = Object.assign({}, {
            name: "Home Internet Plan - Broadband fact labels",
            flow: "broadband facts fios"      }) 
    }
    if (dtmdomainurl.indexOf("/urc") !== -1) {
        adobesuite = document.domain.indexOf("www.verizon.com") !== -1 ? "verizontelecomglobal" : "verizontelecomglobaldev";
    }
    if (pageInfo === "buildFiosInit" && InHomeUtils.isNotNull(stateInfo.lqInfo)
        && InHomeUtils.isNotNull(stateInfo.lqInfo.doFlowDetails)
        && stateInfo.lqInfo.doFlowDetails.isDoFlow && !stateInfo.isSmartCartFlow) {
        initData = Object.assign({}, initData, {
            events: initData.events + ",scAdd",
        })
    }
    // CETC-142916 - Add event86 on ResumeCart call.
    if (pageInfo === "buildFiosInit" && InHomeUtils.isNotNull(stateInfo.isSmartCartFlow) && stateInfo.isSmartCartFlow) {
        initData = Object.assign({}, initData, {
          events: "event86,"+ initData.events,
          detail: "resumeSavedCart"
  
       })
     }

    if (pageInfo === "buildFiosInit" && InHomeUtils.isNotNull(stateInfo.appState)
        && InHomeUtils.isNotNull(stateInfo.appState.flowType) && stateInfo.appState.flowType == '15G') {
        initData = Object.assign({}, initData, {
            events: initData.events + ",scAdd,scOpen",
        })
    } 
    if (pageInfo === "nsiregistrationinit") {
        initData = Object.assign({}, {
            name: "Registration Page",
                  }) 
    } 
    if (pageInfo === "interOrderSum" || pageInfo === "movesInterOrderSum") {
        initData = Object.assign({}, {
            name: pageInfo === "movesInterOrderSum"?"Order Summary Interstitial Page - Moves Flow":"Interstitial Order Summary Page",
            detail: "review your order"
        }) 
    }  
    let eventName = pageNameDetail == '' ? 'pageViewOmni' : pageNameDetail;
    if (stateInfo ?.lqInfo ?.selectedAdr) {
        updateVzdlObjectValues("pageView", stateInfo ?.lqInfo ?.selectedAdr, "", "", "");
    } 
  
    if(isvzfwFlag && ( pageInfo === "buildFiosInit" || pageInfo === "buildFiosSupp" || pageInfo === "buildTwsInit" || pageInfo === "checkoutInitIndex" || pageInfo === "interOrderSum") ){
        vzdl.page.detail = "message displayed"
        tempVzdlSCData.contentFragments = `You are qualified for the verizon Forward${isVzfwdNyOffer ? ' - NY': '' } and other discounts. Internet plan prices reflect discounted cost.`;
        vzdl.page.contentFragments =  `You are qualified for the verizon Forward${isVzfwdNyOffer ? ' - NY': '' } and other discounts. Internet plan prices reflect discounted cost.`;
        vzdl.target.campaign="Fios NC: &intcmp=vf3-buildproducts-continue";
    }
    if(pageInfo === "buildFiosInit"){
        vzdl.target.message = stateInfo?.buildproductInfo?.footerMessage;
        targetMessageFlag = true;
        setTimeout(()=>{vzdl.target.message = "";
            targetMessageFlag = false;},9000)
    }
    if(stateInfo?.contentFrag!==""){
        vzdl.page.contentFragments=stateInfo?.contentFrag;
    }
    if((window?.location?.pathname.indexOf('/inhome/streamlineordering') > -1 || window?.location?.pathname.indexOf('/inhome/streamlinetvvoice')  > -1) && stateInfo?.lqInfo?.streamlineLQ){
        const throttleListStreamline = InHomeUtils.getCookie('cdlThrottleList', document.cookie) 
        if( throttleListStreamline !== null && throttleListStreamline !== ""){
        vzdl.target.sandbox = throttleListStreamline
        if((throttleListStreamline.includes("LQSO_T_Streamline_P") || throttleListStreamline.includes("LQSO_T_Streamline_L"))){
        
        //vzdl.page.throttle = 'so_y|pred_y';
        updateSandboxIdValue(throttleListStreamline.includes("LQSO_T_Streamline_P") ? 'LQSO_T_Streamline_p_fios' : 'LQSO_T_Streamline_L_Fios');
        }
        else{
            updateSandboxIdValue('LQSO_T_Streamline_p_fios'); 
        }

        let throttlestreamvalue='so_y|pred_y';
        if(throttleListStreamline.includes("LQSO_T_Streamline_L")){
            if(isMnhEligible){
                throttlestreamvalue =throttlestreamvalue+'|mh_y';
            }
            else{
                throttlestreamvalue =throttlestreamvalue+'|mh_n'; 
            }
        }
        
        updateThrottleValue(throttlestreamvalue);
        }
        else{
            
            updateSandboxIdValue('LQSO_T_Streamline_p_fios');
            updateThrottleValue('so_y|pred_y');
            let throttlestreamvalue='so_y|pred_y';
            
            if(throttleListStreamline.includes("LQSO_T_Streamline_L")){
                if(isMnhEligible){
                    throttlestreamvalue =throttlestreamvalue+'|mh_y';
                }
                else{
                    throttlestreamvalue =throttlestreamvalue+'|mh_n'; 
                }
            }
        }
        let streamlinename =  (window?.location?.pathname.indexOf('/inhome/streamlineordering') > -1) ? 'Streamline Buildproducts - Internet & Perks' : (window?.location?.pathname.indexOf('/inhome/streamlinetvvoice') > -1) ? 'Streamline Buildproducts - TV & Phone' :'buildproducts';
        
        initData = Object.assign({}, {
            name: streamlinename,            
        });
        
        tempVzdlSCData.name = streamlinename;        
        scVzdlDataDetails['buildFiosInit'].name =streamlinename;
        scVzdlDataDetails['cartAddService'].name =streamlinename;
        scVzdlDataDetails['cartAddService15G'].name =streamlinename;
        scVzdlDataDetails['winBackLoad'].name =streamlinename;
        scVzdlDataDetails['winBackPage'].name =streamlinename;
        scVzdlDataDetails['prodView'].name =streamlinename;
        scVzdlDataDetails['accordionOpen'].name =streamlinename;
        
    }
    else if((window?.location?.pathname.indexOf('/inhome/buildproducts') > -1 || window?.location?.pathname.indexOf('/inhome/ordersummary') > -1 || window?.location?.pathname.indexOf('/inhome/checkout') > -1)){
        const streamlinethrottleListCookie = InHomeUtils.getCookie('cdlThrottleList', document.cookie);       
        if(streamlinethrottleListCookie!== null && streamlinethrottleListCookie!=='' && (streamlinethrottleListCookie.includes("LQSO_C_Streamline_P") || streamlinethrottleListCookie.includes("LQSO_C_Streamline_L"))){
            updateSandboxIdValue(streamlinethrottleListCookie.includes("LQSO_C_Streamline_P")?'LQSO_C_Streamline_p_fios':'LQSO_C_Streamline_L_Fios');
            let throttlestreamvalue='so_n|pred_n';
            if(streamlinethrottleListCookie.includes("LQSO_C_Streamline_L")){
                if(isMnhEligible){
                    throttlestreamvalue =throttlestreamvalue+'|mh_y';
                }
                else{
                    throttlestreamvalue =throttlestreamvalue+'|mh_n'; 
                }
            }
            updateThrottleValue(throttlestreamvalue);
        }
        
        
    }
    if(pageInfo==="interOrderSum" && isRoommateScenerio){
        updateMessageValue("Action required - According to our records, this address already has an active service")
    }
    defaultEventUpdates(eventName, pageInfo, stateInfo, initData);
}

export const vzdlErrorUpdate = (code, msg, event, detailname = "") => {
    // if (vzdl && vzdl.error && vzdl.error.code !== "") {
    //     vzdl.error.code = `${vzdl.error.code}^${code}|${msg}`;
    // }
    // else
    if (vzdl && vzdl.error) {
        vzdl.error.code = `${code}|${msg}`;
        if (event !== undefined || event !== '') {
            if (window && window.vzdl && window.vzdl.event && window.vzdl.event.value) {
                window.vzdl.event.value = event;
            }
        }
        vzdl.page.detail = detailname !== "" ? detailname : pageDetailObj.error;
        if(msg && msg.toLowerCase().includes('lbo')){
            vzdl.page.name = 'lbo';
        }
        vzdl.txn.noOfInstallDays = '';
        sendCustomEvent('pageViewOmni');
    }

}
export const customEventUpdate = (tempSCVzdlJSON, eventname, objName = "") => {
    let appState = store && store.getState && store.getState().app;
    let pfbautopayInfo = store && store.getState && store.getState().pfbautopay;
    let checkoutInfo = store && store.getState && store.getState().checkout;
    let fbeInfo = store && store.getState && store.getState().firstbill;
    if (tempSCVzdlJSON !== "") {
        // populatingVzdlPageObject();
        vzdl.page.name = tempSCVzdlJSON.name
        vzdl.page.detail = tempSCVzdlJSON.detail
        if(tempSCVzdlJSON.prdQualified !==""){
            vzdl.user.productsQualified= sequentialFiosComboOrder? "Triple-fdata-fphone-ftv" : tempSCVzdlJSON.prdQualified
        }
    }
    vzdl.env.businessUnit ="Wireline";
    try {
        let newEvent = {
            "error": vzdl.error,
            "page": vzdl.page,
            "event": vzdl.event,
            "search": vzdl.search,
            "target": vzdl.target,
            "txn": vzdl.txn,
            "rtci": vzdl.rtci,
            "user": vzdl.user,
            "utils": vzdl.utils,
            "env": vzdl.env
        }

        if ((objName === "upsellInit" || objName === "addrVerification") && InHomeUtils.isFlowTypeCheckMoves()) {
            tempSCVzdlJSON.flowName = "accord move";
        }
        else if (objName === "addrVerification" && !InHomeUtils.isFlowTypeCheckMoves()) {
            tempSCVzdlJSON.flowName = "prospect accord";
        }
        if (InHomeUtils.isNotNull(tempSCVzdlJSON.flowName) && !InHomeUtils.isFlowTypeCheckMoves()) {
            if (tempSCVzdlJSON.isMixMatch) {
                if (tempSCVzdlJSON.pageName.indexOf("smart cart") === -1 && tempSCVzdlJSON.flowName.indexOf("mix match") === -1) {//if not smart cart check for mix match if not add it
                    console.log("not smart cart and not mixmatch");
                    newEvent.page.flowName = tempSCVzdlJSON.flowName + " + mix match";
                }
                else if (tempSCVzdlJSON.pageName.indexOf("smart cart") !== -1 && tempSCVzdlJSON.flowName.indexOf("mix match") !== -1) {
                    console.log("smart cart and mixmatch");
                    newEvent.page.flowName = tempSCVzdlJSON.flowName.replace(" + mix match", "");
                }
                else {
                    console.log("no change in flowname");
                    newEvent.page.flowName = tempSCVzdlJSON.flowName;
                }
            }
            else {
                console.log("is mixmatch false");
                newEvent.page.flowName = tempSCVzdlJSON.flowName.replace(" + mix match", "");
            }

        }
        else {
            newEvent.page.flowName = tempSCVzdlJSON.flowName;
        }
        if (InHomeUtils.isFlowTypeCheckMoves()) {
            const moveExp_Cust = store && store.getState && store.getState().moveExp && store.getState().moveExp.cust_opt;
            const lqStateFCPFlow = store && store.getState && store.getState().loopQual && store.getState().loopQual.isFCPflow;
            if ((InHomeUtils.isNotNull(moveExp_Cust) && moveExp_Cust === "SEAMLESS") || (window.location.href.indexOf('moves/landing') > -1 && (objName === "faq" || objName === "seamlessMoves"))) {
                newEvent.page.flowName = "accord seamless move";
                newEvent.page.flow = "accord seamless move";
            }
            else {
                newEvent.page.flowName = "accord move";
                newEvent.page.flow = "accord move";
            }
            if ((InHomeUtils.isNotNull(lqStateFCPFlow) && lqStateFCPFlow)) {
                newEvent.page.flowName = newEvent.page.flowName + " + mix match";
                newEvent.page.flow = newEvent.page.flow + " + mix match";
            }
        }

        window.vzdl = newEvent;
        window.vzdl = window.vzdl || {};
        window.vzdl.event.value = tempSCVzdlJSON.events;
        if (tempVzdlSCData.autoPay !== "") {
            window.vzdl.txn.autoPay = tempVzdlSCData.autoPay;
        }
        if (tempVzdlSCData.TwsTransactionID !== "") {
            window.vzdl.rtci.TwsTransactionID = tempVzdlSCData.TwsTransactionID;
        }
        if (tempVzdlSCData.UNID !== "") {
            window.vzdl.rtci.UNID = tempVzdlSCData.UNID;
        }
        if (tempVzdlSCData.Startdatetimestamp !== "") {
            window.vzdl.rtci.Startdatetimestamp = tempVzdlSCData.Startdatetimestamp;
        }
        if (tempVzdlSCData.Enddatetimestamp !== "") {
            window.vzdl.rtci.Enddatetimestamp = tempVzdlSCData.Enddatetimestamp;
        }
        if (tempVzdlSCData.Status !== "") {
            window.vzdl.rtci.Status = tempVzdlSCData.Status;
        }
        if (tempVzdlSCData.Vendor !== "") {
            window.vzdl.rtci.Vendor = tempVzdlSCData.Vendor;
        }
        if (tempVzdlSCData.TWSsegment !== "") {
            window.vzdl.rtci.TWSsegment = tempVzdlSCData.TWSsegment;
        }
        if (tempVzdlSCData.TWSsubgroup !== "") {
            window.vzdl.rtci.TWSsubgroup = tempVzdlSCData.TWSsubgroup;
        }
        if (tempVzdlSCData.detail && tempVzdlSCData.detail.indexOf("crd chk") > -1 && tempVzdlSCData.creditCheck !== "" && tempVzdlSCData.creditCheckstatus !== "") {
            // user.creditappnum// <Credit aproval status> - pass with deposit , pass without deposit, fail with deposit, fail without deposit.
            if(window && window.vzdl && window.vzdl.user) {
                window.vzdl.user.creditAppNum = "wireline| " + tempVzdlSCData.creditCheckstatus;
            }
        }        
        if (tempVzdlSCData.detail && (tempVzdlSCData.detail.indexOf("save passive") > -1 || tempVzdlSCData.detail.indexOf("smart cart confirmation") > -1 || tempVzdlSCData.detail.indexOf("save proactive") > -1)) {
            let stateInfo = {
                fbeInfo
            }
            //PRODDEF-39046 - Restricting txn.id to be populated only for order confirmation page
            if(window.location.href.includes('/summary')){
                vzdl.txn.id = appState && appState.mon_no;
            }
            else{
                vzdl.txn.id = "";
            }
            vzdl.txn.autoPay = InHomeUtils.isNotNull(pfbautopayInfo) && pfbautopayInfo.autopayChecked ? "Enabled" : "Disabled";
            vzdl.txn.discountId = (getDiscountId(stateInfo)).toString();
            vzdl.txn.paymentType = InHomeUtils.isNotNull(pfbautopayInfo) && InHomeUtils.isNotNull(pfbautopayInfo.paymentmodeSelection) && InHomeUtils.isNotEmpty(pfbautopayInfo.paymentmodeSelection) && pfbautopayInfo.autopayChecked ? pfbautopayInfo.paymentmodeSelection : "",
            vzdl.txn.installOptions = InHomeUtils.isNotNull(checkoutInfo) && InHomeUtils.isNotNull(checkoutInfo.selDueDateType) && InHomeUtils.isNotEmpty(checkoutInfo.selDueDateType) ? checkoutInfo.selDueDateType : "";
            vzdl.txn.cartId = appState && appState.mon_no; // VCGBQA-1465
            }
        if(eventname === "sendData"){
            sendDataEvent(vzdl.event.value);
        }
        else{      
        sendCustomEvent(eventname);        
        }
    }
    catch (ex) {
        console.log("customEventUpdate" + ex.message);
        catchJSException('LaunchScript', "visitId", 'customEventUpdate', ex);
    }
}

const populatingStateValues = (stateInfo) => {
    if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.services)) {
        let srvcs = stateInfo.services;
        serviceQualified = 'single-';
        for (let i = 0; i < srvcs.length; i++) {
            if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'FiOSData') {
                serviceQualified += serviceQualified !== 'single-' ? '+fdata' : 'fdata';
            } else if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'Video') {
                serviceQualified += serviceQualified !== 'single-' ? '+ftv' : 'ftv';
                serviceQualified = serviceQualified.replace('single', 'double');
            } else if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'Voice') {
                serviceQualified += (serviceQualified !== 'double-'|| serviceQualified !== 'single-')  ? '+fphone' : 'fphone';
                serviceQualified = serviceQualified.indexOf("single") > -1 ?serviceQualified.replace('single', 'double'):serviceQualified.replace('double', 'triple');
            }
        }
    }

    // CETC-143221 - Fixes
    let flowVal = "nc-";
    if(InHomeUtils.isNotNull(vzdl) && InHomeUtils.isNotNull(vzdl.txn.orderType) && (vzdl.txn.orderType === "Moves")){
        flowVal =  "ec-"
    }
    return  flowVal + serviceQualified;
}
const defaultEventUpdates = (eventName, pageInfo, stateInfo, initData) => {
    let dtmdomainurl = window.location.href.toLowerCase();
    let flowName = dtmdomainurl.indexOf("/clu") !== -1 ? "" : "prospect accord";
    let sflowName = getFlowName(stateInfo, pageInfo, flowName);
    flowName = sflowName;
    const isFIOSFlow = sessionStorage?.getItem("fiosReferralFlow");    
    let isRedirectionFromPopular = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.isRedirectionFromPopular ? store.getState().buildProduct.isRedirectionFromPopular : false;

    try {
        if (eventName === "pageViewOmni" || eventName === "Checkout" || eventName === "submitorder") {
            populatingVzdlPageObject(stateInfo, pageInfo, flowName, initData);
            populatingVzdlUserObject(stateInfo, pageInfo, initData);
            populatingVzdlEventObject(stateInfo, pageInfo, initData);
            populatingVzdltxnObject(stateInfo, pageInfo, initData);
            populatingVzdlTargetObject(stateInfo, pageInfo, flowName, initData);
            populatingSessionVzdlObjects(stateInfo, pageInfo, initData);
            updatePendingDisconnectSubFlow(stateInfo);
            vzdl.env.businessUnit ="Wireline";

            if ((pageInfo === "buildFiosInit" || pageInfo ==="interOrderSum" || pageInfo ==='movesInterOrderSum') && !(stateInfo.skipPopulatingFlag && stateInfo.skipPopulatingFlag === 'Y')) {
                let latestCartState =  store && store.getState() && store.getState().cart;
                if (InHomeUtils.isNotNull(latestCartState)
                    && InHomeUtils.isNotNull(latestCartState.cartResponse) && InHomeUtils.isNotNull(latestCartState.cartOrderDetail)) {
                    vzdl.txn.product.current = getProductObject(latestCartState.cartOrderDetail, latestCartState.cartResponse, stateInfo.appInfo.flowType);
                if(pageInfo==='buildFiosInit' || pageInfo === "streamlineOdering"){
                    vzdl.event.value = vzdl.event.value + ",scAdd,scOpen"; 
                }     
                    generateValueBayouCombo();             
                }
            }
            if((pageInfo === "seamlessMoves" || pageInfo === "nonSeamlessMoves") && window.sessionStorage?.MovesLandigLoaded){
                vzdl.event.value = "";
            }
            if(isRedirectionFromPopular){
                vzdl.event.value = 'scAdd'
            }

            let newEvent = {
                "error": vzdl.error,
                "page": vzdl.page,  
                "event": vzdl.event,
                "search": vzdl.search,
                "target": vzdl.target,
                "txn": vzdl.txn,
                "rtci": vzdl.rtci,
                "user": vzdl.user,
                "utils": vzdl.utils,
                "env": vzdl.env
            }
            window.vzdl = newEvent;
            window.vzdl = window.vzdl || {};
            if (isFIOSFlow) {               
                vzdl.page.flow = "Fios Referral";
            }
            sendCustomEvent(eventName);
        }
        if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "SUPP" && InHomeUtils.isNotNull(stateInfo.profileInfo)) {
            vzdl.user.customerType = getCustomerType(stateInfo.profileInfo);
        }
        if(vzdl.page.subFlow === "do"){
            vzdl.page.subFlow = "byob";
        }
            if(window && window.sessionStorage && window.sessionStorage.getItem("strc")!= null && window.sessionStorage.getItem("strc") === "Y"){
                if(window.sessionStorage.getItem("strcEmailFlow")!= null && window.sessionStorage.getItem("strcEmailFlow") === "true"){
                    vzdl.page.subFlow = "byob|sot_e";
                }else{
                    vzdl.page.subFlow = "byob|sot_r";
                }
            }
        

        //If EC flow add profile data
        if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "AF" && InHomeUtils.isNotNull(stateInfo.signInInfo) && InHomeUtils.isNotNull(stateInfo.signInInfo.response) && InHomeUtils.isNotNull(stateInfo.signInInfo.response.userProfile) && InHomeUtils.isNotNull(stateInfo.signInInfo.response.userProfile.customerType)) {
            vzdl.user.customerType = stateInfo.signInInfo.response.userProfile.customerType;
        }
        if (pageInfo === "buildFiosInit" || pageInfo === "buildFiosSupp" || pageInfo === "checkoutInitIndex" || pageInfo === "checkoutInit" || pageInfo === "quickcheckoutInit" || pageInfo === "checkoutInitSupp" || pageInfo === "flowCompleted" || pageInfo === "quickcheckoutsummaryInit" || pageInfo === "summaryInitSupp" || pageInfo === "seamlessMoves" || pageInfo === "checkoutMoves" || pageInfo === "summaryMoves" || pageInfo === "buildFiosMoves" || pageInfo === "nonSeamlessMoves" || pageInfo === "buildTwsInit" || pageInfo === 'interOrderSum' || pageInfo === "movesInterOrderSum") {
            if (InHomeUtils.isNotNull(stateInfo)
                && InHomeUtils.isNotNull(stateInfo.cartInfo)
                && InHomeUtils.isNotNull(stateInfo.cartInfo.cartResponse) && InHomeUtils.isNotNull(stateInfo.cartInfo.cartOrderDetail)) {
                vzdl.txn.product.current = getProductObject(stateInfo.cartInfo.cartOrderDetail, stateInfo.cartInfo.cartResponse, stateInfo.appInfo.flowType)
                generateValueBayouCombo();  
            }

        }
        else if (pageInfo === "pega")
            if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.cartInfo) && InHomeUtils.isNotNull(stateInfo.cartInfo.orderDetail) && InHomeUtils.isNotNull(stateInfo.cartInfo.tierPricing)) {
                vzdl.txn.product.current = getProductObject(stateInfo.cartInfo.orderDetail, stateInfo.cartInfo.tierPricing, stateInfo.appInfo.flowType);
                generateValueBayouCombo();  
            }

        if (pageInfo === "fccbroadbandlabelsinit"){
                vzdl.page.flow = "broadband facts fios",
                vzdl.page.displayChannel = "vzf",
                vzdl.page.channel = "learn"
            }           
        if(pageInfo === "checkoutInitIndex"){
            populatingSessionVzdlObjects(stateInfo, pageInfo, initData);
        }         
        vzdl.env.businessUnit ="Wireline";
        window.vzdl.event = window.vzdl.event || [];
    }
    catch (ex) {
        console.log("defaultEventUpdates" + ex.message);
        catchJSException('LaunchScript', "visitId", 'defaultEventUpdates', "defaultEventUpdates:" + ex);
    }

}
export const updateFragmentsValue=(stateInfo)=>{
    let isvzfwFlag =  stateInfo?.isVZFwdFlag?true:false;
    const isVzfwdNyOffer = stateInfo?.isVzfNYDiscount;
    if(isvzfwFlag)
        vzdl.page.contentFragments=`You are qualified for the verizon forward${isVzfwdNyOffer ? ' - NY': '' } and other discounts. Internet plan prices reflect discounted cost.`;
    else
        vzdl.page.contentFragments ="";
}
const populatingSessionVzdlObjects = (stateInfo, pageInfo, initData) => {
    //Throttle Value session checking
    if(pageInfo === "checkoutInitIndex" || pageInfo==="checkoutMoves"){

        //session sandbox setting values
        if(window.sessionStorage && (vzdl.target.sandbox === '' || vzdl.page.throttle === ''))
        {
            // if(window.sessionStorage.orderSummaryInterstial === 'true' || window.sessionStorage.orderSummaryInterstial ){            
            //     updateSandboxIdValue('fios_os');
            // }
            // else {
            //     updateSandboxIdValue('fios_c_os');            
            // }

            //Removing Logic based on ACt112-516
            // if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.checkoutInfo) && InHomeUtils.isNotNull(stateInfo.checkoutInfo.accordionStatus) && InHomeUtils.isNotNull(stateInfo.checkoutInfo.accordionStatus.creditCheck) &&  stateInfo.checkoutInfo.accordionStatus.creditCheck === "completed") {            

            //     if(window.sessionStorage?.creditCheckV2 === true || window.sessionStorage?.creditCheckV2 === "true"){
            //         updateSandboxIdValue('fios_cc');
            //         updateThrottleValue('Enhance crd chk');

            //     } else 
            //     {
            //         updateSandboxIdValue('fios_c_cc');
            //         updateThrottleValue('BAU crd chk'); 
            //     } 

            // }          
        } 
    }
    if ((pageInfo === "buildFiosInit" || pageInfo === "interOrderSum" || pageInfo === "movesInterOrderSum") &&  stateInfo?.appInfo?.flowType !== "MV" &&  stateInfo?.appInfo?.flowType !== "SUPP") {
        if(window.sessionStorage){
            // if(window.sessionStorage?.stickyprogressbar){
            //     updateSandboxIdValue(window.sessionStorage?.stickyprogressbar);
            // }
            if(window.sessionStorage?.saveSaleOffer){
                updateSandboxIdValue(window.sessionStorage?.saveSaleOffer);
            }
            if(window.sessionStorage?.enableAuotpayThrottle){
                updateSandboxIdValue(window.sessionStorage?.enableAuotpayThrottle);
            }
        }
    }
    
}

const populatingVzdlPageObject = (stateInfo, pageInfo, flowName, initData) => {
    // vzdl.page.LQZip = ""
    vzdl.page.channel = "Ordering";
    vzdl.page.channelSession = stateInfo.appInfo.visitId;
    vzdl.page.detail = initData.detail;
    vzdl.page.flow = flowName;
    vzdl.page.name = initData.name;
    let mnhIncludedFlag = false 
    if(vzdl?.page?.subFlow && typeof vzdl.page.subFlow === "string" && vzdl.page.subFlow.toLowerCase().includes('m+h')){
        mnhIncludedFlag = true;
    }
    vzdl.page.subFlow = '';
    vzdl.page.throttle = vzdl?.page?.throttle?vzdl.page.throttle:"";
    vzdl.page.contentFragments = vzdl.page.contentFragments? vzdl.page.contentFragments: "";
    vzdl.page.link = "";
    vzdl.page.accBundleFlag = "";
    vzdl.page.cpcFlag = "";
    vzdl.page.deviceDollarsApplied = "";
    vzdl.page.wishListFlag = "";
    vzdl.target.sandbox = vzdl.target?.sandbox ? vzdl.target?.sandbox : "";
    vzdl.utils.aiScoreTime = vzdl.utils.aiScoreTime ? vzdl.utils.aiScoreTime : "";
    let params = new URLSearchParams(window.location.search);
    /*let lq2 = false;
    if(params)
        "/
        lq2 = params.get('lq2');
    }*/
    let mm3Qualified = (stateInfo?.buildproductInfo?.internet?.mm3Qualified || stateInfo?.buildproductInfo?.mnFromApi) || (window.sessionStorage?.mm3Qualified === true || window.sessionStorage?.mm3Qualified === "true");
    let isMnhEligible = stateInfo?.buildproductInfo?.internet?.mnhSignupIndicator!==undefined && stateInfo?.buildproductInfo?.internet?.mnhSignupIndicator!=="" && stateInfo?.buildproductInfo?.internet?.mnhSignupIndicator!=="N"?true:false;
    let isvzfwFlag = stateInfo?.buildproductInfo?.isVZFwdFlag;   
    let isFCPFlow = InHomeUtils.isNotNull(stateInfo.lqInfo) && (stateInfo.lqInfo.isFCPflow || stateInfo.lqInfo.isFcpInProfile);

    if (InHomeUtils.isNotNull(stateInfo.lqInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo.doFlowDetails) && InHomeUtils.isNotNull(stateInfo.lqInfo.doFlowDetails.isDoFlow) && stateInfo.lqInfo.doFlowDetails.isDoFlow) {
        vzdl.page.subFlow = "do";        
    }
    else if (InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "MV") {
        vzdl.page.subFlow = "Moves Flow";
        // CETC-143221 - Fixes
        if(pageInfo === "seamlessMoves" && window.location.href.indexOf('moves/landing') > -1){
            vzdl.page.name = "moves landing";
            movesDirectBuildProduct = false;
        }
        else if(window.location.href.indexOf('/moves/qualification')>-1){
            vzdl.page.detail = 'lq check avail';
        }
        else{
            if(movesDirectBuildProduct && window.location.href.indexOf('moves/buildproducts')>-1){
                vzdl.page.detail = "Please select Internet";
            }

        }       
    }
    else if (InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "SUPP") {
        vzdl.page.subFlow = "Supp Flow";
    }
    else{
        if(vzdl.page.subFlow === '')
        vzdl.page.subFlow =  isvzfwFlag ? "byob |vfwd": sequentialFiosComboOrder? updateSubFlowValue(' | Seq mh', 'seq mh') : "byob";
        
    }   
        
    if((pageInfo === "summaryMoves" || pageInfo === "summaryInitSupp" || pageInfo === "quickcheckoutsummaryInit" || pageInfo === "summaryInit")) {
        try {
            let eligibelTracker = '';
            let mnhDiscount = '';
            let mnhDiscountInOffer = '';
            //Removing Logic based on ACt112-516
            // if(pageInfo === "quickcheckoutsummaryInit" || pageInfo === "summaryInit"){
            //     let creditCheckThrottleVal = (store && store.getState && store.getState().checkout && store.getState().checkout.creditCheckThrottleFlag) || (window.sessionStorage?.creditCheckV2 === true || window.sessionStorage?.creditCheckV2 === "true") ? 'Enhance crd chk' : 'BAU crd chk';
            //     updateThrottleValue(creditCheckThrottleVal);
            // }
            if (stateInfo.cartInfo.cartResponse.tierContent[0] && stateInfo.cartInfo.cartResponse.tierContent[0].sections && stateInfo.cartInfo.cartResponse.tierContent[0].sections.section[0]) {
                stateInfo.cartInfo.cartResponse.tierContent[0].sections.section.map(secObj => {
                    if (secObj.sectionName === "Promotions") {
                        secObj.subSections && secObj.subSections.subSection && secObj.subSections.subSection.map(subSecObj => {
                            if (subSecObj.sectionType && subSecObj.sectionType === "SpecialOffers") {
                                eligibelTracker = subSecObj.promos && subSecObj.promos.filter(p => p.promoId === "R1634" || p.promoId === 'R1633');
                                mnhDiscount = subSecObj.promos && subSecObj.promos.filter(p => p.promoId === "R1636" || p.promoId === 'R1635');
                            }
                            if (subSecObj.sectionType && subSecObj.sectionType === "Offers") {
                                mnhDiscountInOffer = subSecObj.promos && subSecObj.promos.filter(p => p.promoId === "R1636" || p.promoId === 'R1635');
                            }
                        })
                    }
                })
            }
            if (eligibelTracker && eligibelTracker.length > 0) {
                vzdl.page.detail = pageDetailObj.orderConfirmMhEligible;
            } else if ((mnhDiscount && mnhDiscount.length > 0) || (mnhDiscountInOffer && mnhDiscountInOffer.length > 0)) {
                vzdl.page.detail = pageDetailObj.orderConfirmMhEnrolled;
            } else if (InHomeUtils.isNotNull(stateInfo.saveInfo) && InHomeUtils.isNotEmpty(stateInfo.saveInfo.saveLqMtnInput)) {
                vzdl.page.detail = pageDetailObj.orderConfirmMhNotEligible;
            } else {
                vzdl.page.detail = pageDetailObj.orderConfirm;
            }
        } catch (ex) {
            console.log("populatingVzdlPageObject" + ex.message);
        }
    }
    let isACPFlag = store && store.getState && store.getState().buildProduct && store.getState().buildProduct.isACPFlag ? true : false;
    if(isACPFlag){
        vzdl.page.subFlow = 'acp';
    }
    if(vzdl.page.subFlow != '' && !mm3Qualified && !isFCPFlow){
        if(vzdl.page.subFlow===' | M+H')
            vzdl.page.subFlow = 'classic | M+H'
        else
            updateSubFlowValue('|classic','clas')
            // vzdl.page.subFlow += '|classic';

    }
    if(isMnhEligible || mnhIncludedFlag){
        updateSubFlowValue(' | M+H', 'm+h');
    }
    if(sequentialFiosComboOrder){
        updateSubFlowValue(' | seq mh', 'seq mh'); 
    }
       
    
    //if(isvzfwFlag){updateSubFlowValue('|vfwd')}
    // if(isvzfwFlag)
    //     vzdl.page.subFlow += '|vfwd';
}
const populatingVzdlEventObject = (stateInfo, pageInfo, initData) => {
    if ((pageInfo === "buildFiosInit" || pageInfo === "checkoutInitIndex" || pageInfo === "checkoutInit" || pageInfo === "summaryInit") && InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo.runtimeKey) && InHomeUtils.isNotNull(stateInfo.lqInfo.runtimeKey.EnableMHFiosSignIn) 
         && stateInfo.lqInfo.runtimeKey.EnableMHFiosSignIn === "Y" && stateInfo.buildproductInfo && stateInfo.buildproductInfo.internet && stateInfo.buildproductInfo.internet.mnhSignupIndicator 
         && stateInfo.buildproductInfo.internet.mnhSignupIndicator == "Y" ){
        initData = Object.assign({}, initData, {
            events: initData.events + "",
        })
    }
    vzdl.event.value = InHomeUtils.isNotNull(initData.events) ? initData.events : "";
    //CETC-143916
    /*if((pageInfo === "checkoutInitIndex" || pageInfo== "checkoutInit") && InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.buildproductInfo) && InHomeUtils.isNotNull(stateInfo.buildproductInfo.upsell) && stateInfo.buildproductInfo.upsell.isUpsellAddedToCart){
        vzdl.event.value= initData.events + ",scAdd";
    }*/
    //CTEC-143224 Add "scAdd" on checkoutMoves pageInfo
    if((pageInfo === "checkoutMoves"  && InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.movesInfo) && InHomeUtils.isNotNull(stateInfo.movesInfo.movesType) && InHomeUtils.isNotNull(stateInfo.moveExp_Cust) && stateInfo.moveExp_Cust != "NONSEAMLESS" )){
           vzdl.event.value= initData.events+",scAdd";
       }
    if (pageInfo === "buildFiosMoves" && InHomeUtils.isNotNull(stateInfo.movesInfo)
       && InHomeUtils.isNotNull(stateInfo.movesInfo) && stateInfo.isMoveLandingPage) {
            vzdl.event.value= "";
    }

    if((pageInfo === "seamlessMoves" || pageInfo === "nonSeamlessMoves") &&  window.sessionStorage?.MovesLandigLoaded){
        vzdl.event.value ="";
     }
    
}

const populatingVzdlTargetObject = (stateInfo, pageInfo, flowName, initData) => {
    vzdl.target.assetsRequested = "",
        vzdl.target.assetAttributes = "",
        vzdl.target.assetsLeveraged = "",
        vzdl.target.abTest = "",
        vzdl.target.campaign = "",
        vzdl.target.experience = "",
        vzdl.target.message = vzdl.target.message?vzdl.target.message:"",
        vzdl.target.offer = "",
        vzdl.target.cloud = "",
        vzdl.target.mktgId = "",
        vzdl.target.engagement.intent = "Ordering";
        vzdl.target.sandbox = vzdl.target.sandbox ? vzdl.target.sandbox : "";
        let isACPFlag = store && store.getState && store.getState().buildProduct && store.getState().buildProduct.isACPFlag ? true : false;
        let isTWSFlag = store && store.getState && store.getState().buildProduct && store.getState().buildProduct.isTWSFlag ? store.getState().buildProduct.isTWSFlag : "";
        let isvzfwFlag = stateInfo?.buildproductInfo?.isVZFwdFlag;
        const isVzfwdNyOffer = stateInfo?.buildproductInfo?.isVzfNYDiscount;
        let isMnhEligible = stateInfo?.buildproductInfo?.internet?.mnhSignupIndicator!==undefined &&stateInfo?.buildproductInfo?.internet?.mnhSignupIndicator!=="" && stateInfo?.buildproductInfo?.internet?.mnhSignupIndicator!=="N"?true:false;
        if(isACPFlag && pageInfo === "buildFiosInit"){
            vzdl.target.message = 'You qualify for the affordable connectivity program discount';
            targetMessageFlag = true;
        }
        if(isvzfwFlag ){
            if(pageInfo === "buildFiosInit"){
                vzdl.target.message = `You are qualified for the verizon forward${isVzfwdNyOffer ? ' - NY': '' } and other discounts. Internet plan prices reflect discounted cost.`;
                targetMessageFlag = true;
            }         
            if(pageInfo === "buildFiosInit" || pageInfo === "checkoutInitIndex" || pageInfo === "interOrderSum" || pageInfo === "summaryInit")
            vzdl.target.campaign="vf3-buildproducts-continue";
        }
        if(isMnhEligible && (pageInfo === "buildFiosInit" || pageInfo === "checkoutInitIndex")){
            vzdl.target.message = "Congratulations you're getting for Mobile+Home Discount";
            targetMessageFlag = true;
        }

        if(pageInfo === "fccbroadbandlabelsinit"){
            vzdl.target.engagement.intent = "learn";
        }
        if(pageInfo === "buildFiosInit"){
            const search = window.location.search;
            const parameters = new URLSearchParams(search);
            let message = "";
            if(isTWSFlag!== ""){
                message = InHomeUtils.isNotNull(parameters.get('type')) ? parameters.get('type') : '';
                if(message === "medical"){
                    message = "nurse";
                }
            }
            if(isTWSFlag === 'Y'){
                vzdl.target.message = 'Congratulations you are qualified for the ' + message+ ' discount';
                targetMessageFlag = true;
            }
            else if(isTWSFlag === 'N'){
                vzdl.target.message = 'Unfortunately you are not-qualified for the ' + message+ ' discount';
                targetMessageFlag = true;
            }
        }
        if(InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo.lqResponse) && stateInfo.lqInfo.lqResponse.wirelessPlanType) {
            vzdl.target.offer =stateInfo.lqInfo.lqResponse.wirelessPlanType;
        }
             
        if (pageInfo === "fiosReferral") {
            vzdl.target.engagement.intent = "Instore - Home Referral";
        }
        else if(pageInfo === "ruralLboInit"){
            vzdl.target.message = "Good news, Fios Services is available at your address. To set up your service call us at 866.909.2198";
            targetMessageFlag = true;
        }

    
}

const getOwnCart = (stateInfo) => {
    try {
        let cartData = stateInfo.stateInfo.profileCart.cartData[0];
        let promoProduct = [];
        let channelsNotInPack = [];
        let equipmentProduct = [];
        let fiosFiveSelectedChannels = [];
        let listing = [];
        let oneTimeCharge = [];
        let removedServices = [];
        let removedequipments = [];
        let rewardOffers = [];
        let serviceHeaders = [];
        let youtubePrd = [];
        let streamService = [];
        if (cartData == undefined)
            return null;
        if (cartData.Promotions && cartData.Promotions.promotions != undefined) {
            promoProduct = cartData.Promotions.promotions.map((ownProduct) => {
                return {
                    name: ownProduct.name || ownProduct.promoText,
                    id: ownProduct.id || ownProduct.promoId,
                    category: "DISCOUNT",
                    recurringPrice: ownProduct.price,
                    line: null
                }
            });
        }
        if (cartData.channelsNotInPack && cartData.channelsNotInPack != undefined && cartData.channelsNotInPack.length > 0) {
            channelsNotInPack = cartData.channelsNotInPack.map((channelsNotInPackProduct) => {
                return {
                    name: channelsNotInPackProduct.name,
                    id: channelsNotInPackProduct.id,
                    category: channelsNotInPackProduct.category,
                    recurringPrice: channelsNotInPackProduct.price,
                    line: null
                }
            });
        }
        if (cartData.equipments && cartData.equipments.equipment != undefined) {
            equipmentProduct = cartData.equipments.equipment.map((equipmentProduct) => {
                return {
                    name: equipmentProduct.prodName,
                    id: equipmentProduct.prodId,
                    category: equipmentProduct.prodType,
                    recurringPrice: equipmentProduct.price,
                    line: null
                }
            });
        }
        if (cartData.fiosFiveSelectedChannels != undefined) {
            fiosFiveSelectedChannels = cartData.fiosFiveSelectedChannels.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.prodId,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.listing && cartData.listing.listingProds != undefined && cartData.listing.listingProds) {
            listing = cartData.listing.listingProds.map((listingProduct) => {
                return {
                    name: listingProduct.prodName,
                    id: listingProduct.id,
                    category: null,
                    recurringPrice: listingProduct.price,
                    line: null
                }
            });
        }
        if (cartData.oneTimeCharge != undefined) {
            oneTimeCharge = cartData.oneTimeCharge.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.id,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.removedServices != undefined) {
            removedServices = cartData.removedServices.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.id,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.removedequipments != undefined) {
            removedequipments = cartData.removedequipments.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.id,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.rewardOffers && cartData.rewardOffers.rewardOffers != undefined) {
            rewardOffers = cartData.rewardOffers.rewardOffers.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.id,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.serviceHeaders && cartData.serviceHeaders.servicehead != undefined) {
            serviceHeaders = cartData.serviceHeaders.servicehead.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.prodId,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.youtubePrd && cartData.youtubePrd.youtubePrd != undefined) {
            youtubePrd = cartData.youtubePrd.youtubePrd.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.prodId,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.streamService && cartData.streamService.streamServiceProds != undefined) {
            streamService = cartData.streamService.streamServiceProds.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.prodId,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        return [].concat(promoProduct, channelsNotInPack, equipmentProduct, fiosFiveSelectedChannels, listing, oneTimeCharge, removedServices, removedequipments, rewardOffers, serviceHeaders, youtubePrd);
    }
    catch (ex) {
        catchJSException('vzdl', "visitId", 'getOwnCart', "getOwnCart:" + ex);
    }
}

const populatingVzdltxnObject = (stateInfo, pageInfo, initData) => {
    if(stateInfo && stateInfo.appInfo && stateInfo.appInfo.flowType === "MV"){
        if(store && store.getState()){
            let stateCurr = { stateInfo: store.getState()}
            if (stateCurr && stateCurr.stateInfo && InHomeUtils.isNotNull(stateCurr.stateInfo.profileCart) && InHomeUtils.isNotNull(stateCurr.stateInfo.profileCart.cartData) && stateCurr.stateInfo.profileCart.cartData.length > 0) {
                vzdl.txn.product.owns = getOwnCart(stateCurr);
            }
        }
    }
    // getVzdltxnObjects(),
    vzdl.txn.agent = "";
    //For Supp flow we will land into buildproduct               
    // pfbautopayInfo.autopayChecked   
    if (pageInfo === "checkAvaillqInit" || pageInfo === "flowInitiated" || pageInfo === "buildFiosInit" || pageInfo === "checkoutInitIndex" || pageInfo === "checkoutInit") {
        vzdl.txn.autoPay = "Enabled";
    }
    else {
        vzdl.txn.autoPay = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.pfbautopayInfo) && stateInfo.pfbautopayInfo.autopayChecked ? "Enabled" : "Disabled";
    }
    if(pageInfo && pageInfo === "summaryInit" || pageInfo === "summaryInitSupp" || pageInfo === "quickcheckoutsummaryInit" || pageInfo === "summaryMoves"){
        if(!stateInfo.creditInfo.isCreditCheckCleared){
            vzdl.txn.status = "order on hold";
        }
        else{
            vzdl.txn.status = "order confirmed";
        }
    }
    else{
        vzdl.txn.status = "";
    }
    vzdl.txn.noOfInstallDays = '';
    //PRODDEF-39046 - Restricting txn.id to be populated only for order confirmation page
    if(window.location.href.includes('/summary')){
        vzdl.txn.id = stateInfo.appInfo.mon_no;
    }
    else{
        vzdl.txn.id = "";
    }
    vzdl.txn.offer = "";
    vzdl.txn.discountId = (getDiscountId(stateInfo)).toString();
    vzdl.txn.orderType = getOrderType(stateInfo);
    //vzdl.txn.status = (pageInfo && pageInfo === "summaryInit" || pageInfo === "summaryInitSupp" || pageInfo === "quickcheckoutsummaryInit" || pageInfo === "summaryMoves") ? "order confirmed" : "",
    vzdl.txn.cartId = stateInfo.appInfo.mon_no; // VCGBQA-1465
    vzdl.txn.outletId = sessionStorage.getItem("fiosReferralFlow") === "true" && sessionStorage.getItem("orderLoc") !== null ? sessionStorage.getItem("orderLoc") : "";
    vzdl.txn.quoteid = "";
    vzdl.txn.paymentType = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.pfbautopayInfo) && InHomeUtils.isNotNull(stateInfo.pfbautopayInfo.paymentmodeSelection) && InHomeUtils.isNotEmpty(stateInfo.pfbautopayInfo.paymentmodeSelection) && stateInfo.pfbautopayInfo.autopayChecked ? stateInfo.pfbautopayInfo.paymentmodeSelection : "";
    vzdl.txn.shippingZip = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo.selectedAdr) && InHomeUtils.isNotNull(stateInfo.lqInfo.selectedAdr.zip) ? stateInfo.lqInfo.selectedAdr.zip : "";
    vzdl.txn.shippingTotal = "0";
    vzdl.txn.shippingCharge = "";
    vzdl.txn.tradeInQty = "";
    vzdl.txn.tradeInAmt = "";
    // // vzdl.txn.total = InHomeUtils.isNotNull(stateInfo) && stateInfo.fbeInfo && stateInfo.fbeInfo.getsoc && stateInfo.fbeInfo.getsoc.socResponse.totalRecurringCharges ? stateInfo.fbeInfo.getsoc.socResponse.totalRecurringCharges : "", 
    // // vzdl.txn.recurringCharges = InHomeUtils.isNotNull(stateInfo) && stateInfo.fbeInfo && stateInfo.fbeInfo.getsoc && stateInfo.fbeInfo.getsoc.socResponse.totalRecurringCharges ? stateInfo.fbeInfo.getsoc.socResponse.totalRecurringCharges : "",
    // // vzdl.txn.nonRecurringCharges = InHomeUtils.isNotNull(stateInfo) && stateInfo.fbeInfo && stateInfo.fbeInfo.getsoc && stateInfo.fbeInfo.getsoc.socResponse.totalNonRecurringCharges ? stateInfo.fbeInfo.getsoc.socResponse.totalNonRecurringCharges : "",
    vzdl.txn.futurePayment = "";
    if (pageInfo !== "buildFiosInit" && pageInfo !== "seamlessMoves") {
        vzdl.txn.total = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.cartInfo) && InHomeUtils.isArray(stateInfo.cartInfo.cartHeader) && InHomeUtils.isNotNull(stateInfo.cartInfo.cartHeader) && InHomeUtils.isNotNull(stateInfo.cartInfo.cartHeader[0].totalPrice) ? stateInfo.cartInfo.cartHeader[0].totalPrice.replace('$', '') : "0";
        vzdl.txn.taxAmt = (CalcTaxAmount(stateInfo)).toString();
        vzdl.txn.recurringCharges = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isArray(stateInfo.cartInfo) && InHomeUtils.isNotNull(stateInfo.cartInfo.cartHeader) && InHomeUtils.isNotNull(stateInfo.cartInfo.cartHeader[0].monthlyRcPrice) ? stateInfo.cartInfo.cartHeader[0].monthlyRcPrice.replace('$', '') : "0";
        vzdl.txn.nonRecurringCharges = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isArray(stateInfo.cartInfo) && InHomeUtils.isNotNull(stateInfo.cartInfo.cartHeader) && InHomeUtils.isNotNull(stateInfo.cartInfo.cartHeader[0].totalNrcPrice) ? stateInfo.cartInfo.cartHeader[0].totalNrcPrice.replace('$', '') : "0";
        vzdl.txn.installOptions = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.checkoutInfo) && InHomeUtils.isNotNull(stateInfo.checkoutInfo.selDueDateType) && InHomeUtils.isNotEmpty(stateInfo.checkoutInfo.selDueDateType) ? stateInfo.checkoutInfo.selDueDateType : "";
        vzdl.txn.discount = (getDiscountId(stateInfo)).toString();
    }

    vzdl.txn.paymentAmt = "";
    // vzdl.txn.product.current = [...vzdl.txn.product.current]
    // vzdl.txn.product = {
    //     "discount": "",
    //     "offer": "",
    //     "recurringPrice ": "",
    //     "nonrecurringPrice ": "",
    //     "owns": {
    //         "name": ""
    //     },
    //     "current": {
    //         "name": "",
    //         "id": "",
    //         "merchCat": "merchandising category of the product",
    //         "category": "",
    //         "offer": "",
    //         "discount": "",
    //         "qty": "",
    //         "recurringPrice": "monthly price",
    //         "nonRecurringPrice": "onetime price",
    //         "line": "",
    //         "sku": "",
    //         "contractType": "",
    //         "shippingCharge": "",
    //         "shippingType": "",
    //         "shared": ""
    //     }

    // }
}
const populatingVzdlUserObject = (stateInfo, pageInfo, initData) => {
    vzdl.user.existingServices = "";
    vzdl.user.account = "";
    let isMvaFlow = store && store.getState && store.getState().signIn && (store.getState().signIn.isNCMVAppFlow || store.getState().signIn.isMvAppFlow) ? true : false;
    let isSignedIn = false;
    let signInCookie;
    if(window.cookie){
        signInCookie  = window.cookie.split(";").filter(each => each.includes("islogin") || each.includes("loggedin=true"))[0]
    }
    isSignedIn = ((store && store.getState && store.getState().buildProduct && store.getState().buildProduct.internet && store.getState().buildProduct.internet.mnhSignupIndicator === "Y") || signInCookie) ? true : false;
    if (pageInfo === "seamlessMoves" || pageInfo === "buildFiosMoves" || pageInfo === "summaryMoves" || pageInfo === "checkoutMoves" || (stateInfo.appInfo.flowType === "MV" && pageInfo === "checkAvaillqInit") || (stateInfo.appInfo.flowType === "MV" && pageInfo === "flowInitiated") || isMvaFlow || isSignedIn)
        vzdl.user.authStatus = "logged in";
    else
        vzdl.user.authStatus = "anonymous";
    vzdl.user.tenure = "";
    // vzdl.user.prospect = "";
    vzdl.user.session = stateInfo.appInfo.visitorId;
    vzdl.user.chatId = "";
    vzdl.user.zip = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo.selectedState) && stateInfo.lqInfo.selectedState.zip ? stateInfo.lqInfo.selectedState.zip : "";
    if (pageInfo === "checkoutMoves" || pageInfo === "checkoutInitSupp" || pageInfo === "summaryMoves"
        || pageInfo === "summaryInitSupp" || pageInfo === "summaryInit" || pageInfo === "quickcheckoutsummaryInit") {
        vzdl.user.creditAppNum = getCreditCheckInfo(stateInfo);
    }
    else {
        vzdl.user.creditAppNum = ""
    }
    if (stateInfo.appInfo.flowType === "NC" || stateInfo.appInfo.flowType === "") {
        vzdl.user.accountType = "new customer";
    }else if(stateInfo.appInfo.flowType === "MV" ){ //VCGBQA-1753
        vzdl.user.accountType = "Postpaid";      
        if(InHomeUtils.isNotNull(stateInfo.lqInfo)){
            if(InHomeUtils.isNotNull(stateInfo.lqInfo.vCustId) && stateInfo.lqInfo.vCustId != ''){
                if(accountHashed && accountHashed != ""){
                    vzdl.user.account = accountHashed
                }
                else{
                    getSHA256Val(stateInfo.lqInfo.vCustId,true);
                }
            }
            if(InHomeUtils.isNotNull(stateInfo.lqInfo.vZWvZTCustIndicator) || stateInfo.lqInfo.isVZWWireless === "Y"){
                vzdl.event.value=vzdl.event.value+ ",event9";
             }
            if(InHomeUtils.isNotNull(stateInfo.lqInfo.employeeOfferExists)){
                vzdl.user.customerType = stateInfo.lqInfo.employeeOfferExists ? "ME" : "PE";
            }
            if(InHomeUtils.isNotNull(stateInfo.lqInfo.vZWvZTCustIndicator)){
                vzdl.user.customerBusiness="joint_cust";
            }
            else if(stateInfo.lqInfo.isVZWWireless === "Y"){
                vzdl.user.customerBusiness= "vzw_cust";
            } 
            else if (stateInfo.lqInfo.isVZWWireless === "N"){
                vzdl.user.customerBusiness="vzt_cust";
            }
            else{
                vzdl.user.customerBusiness= "no_cust";
            }
        }
    }

    if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo.lqResponse) && stateInfo.lqInfo.lqResponse.services) {
        vzdl.user.productsQualified = populatingStateValues(stateInfo.lqInfo.lqResponse);
    }
}
const CalcTaxAmount = (stateInfo) => {
    let NRCTax = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.fbeInfo) && InHomeUtils.isNotNull(stateInfo.fbeInfo.getsoc) && InHomeUtils.isNotNull(stateInfo.fbeInfo.getsoc.socResponse) && InHomeUtils.isNotNull(stateInfo.fbeInfo.getsoc.socResponse.socTotalTaxAmountNRC) ? stateInfo.fbeInfo.getsoc.socResponse.socTotalTaxAmountNRC : 0;
    let RCTax = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.fbeInfo) &&InHomeUtils.isNotNull( stateInfo.fbeInfo.getsoc) && InHomeUtils.isNotNull(stateInfo.fbeInfo.getsoc.socResponse) && InHomeUtils.isNotNull(stateInfo.fbeInfo.getsoc.socResponse.socTotalTaxAmountRC) ? stateInfo.fbeInfo.getsoc.socResponse.socTotalTaxAmountRC : 0;
    return parseInt(NRCTax) + parseInt(RCTax);

}
const getDiscountId = (stateInfo) => {
    let Id = "";
    let mrcDiscountProducts = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.fbeInfo) && InHomeUtils.isNotNull(stateInfo.fbeInfo.getsoc) && InHomeUtils.isNotNull(stateInfo.fbeInfo.getsoc.socResponse) && stateInfo.fbeInfo.getsoc.socResponse.mrcDiscountProducts ? true : false;
    if (mrcDiscountProducts) {
        for (let mrcdisprod = 0; mrcdisprod < stateInfo.fbeInfo.getsoc.socResponse.mrcDiscountProducts.length; mrcdisprod++) {
            if (stateInfo.fbeInfo.getsoc.socResponse.mrcDiscountProducts[mrcdisprod].productcode) {
                if (mrcdisprod == 0) {
                    Id = stateInfo.fbeInfo.getsoc.socResponse.mrcDiscountProducts[mrcdisprod].productcode;
                } else {
                    Id = Id + " | " + stateInfo.fbeInfo.getsoc.socResponse.mrcDiscountProducts[mrcdisprod].productcode;
                }
            }
        }
    }
    return Id;
}
const getCreditCheckInfo = (stateInfo, flowName) => {
    let creditStatus = "";
    let depositrequired = "";
    let creditCheckStatus = "";
    if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.creditInfo)) {
        creditStatus = stateInfo.creditInfo.isCreditCheckCleared ? "pass" : "fail";
        depositrequired = stateInfo.creditInfo.isDepositRequired ? "Y" : "N"
    }
    depositrequired = depositrequired === "Y" ? " with deposit" : " without deposit";
    return creditCheckStatus = "wireline| " + creditStatus + depositrequired;
}
const getOrderType = (stateInfo) => {
    let orderTypeObj = {
        newConnect : "New Connect",
        moves : "Moves",
        supp : "SUPP"
    }
    let orderType = 'New Connect'
    if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo)) {
        if (stateInfo.appInfo.flowType === "") {
            orderType = orderTypeObj.newConnect
        }
        else if (stateInfo.appInfo.flowType === "MV") {
            orderType = orderTypeObj.moves
        }
        else if (stateInfo.appInfo.flowType === "SUPP") {
            orderType = orderTypeObj.supp
        }
    }
    return orderType;
}

const getDiscountAmount = (stateInfo) => {
    //Need to work for NRC Discount Price and Looping 
    let mrcDiscPrice = 0;
    let mrcDiscountProducts = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.fbeInfo) && InHomeUtils.isNotNull(stateInfo.fbeInfo.getsoc) && InHomeUtils.isNotNull(stateInfo.fbeInfo.getsoc.socResponse) && stateInfo.fbeInfo.getsoc.socResponse.mrcDiscountProducts ? true : false;
    if (mrcDiscountProducts) {
        for (let mrcdisprod = 0; mrcdisprod < stateInfo.fbeInfo.getsoc.socResponse.mrcDiscountProducts.length; mrcdisprod++) {
            if (stateInfo.fbeInfo.getsoc.socResponse.mrcDiscountProducts[mrcdisprod].price) {
                mrcDiscPrice = stateInfo.fbeInfo.getsoc.socResponse.mrcDiscountProducts[mrcdisprod].price;
            }
        }
    }
    return Math.abs(mrcDiscPrice);
}
const getCustomerType = (profileInfo) => {
    let sCustomerType = "";

    let profileDataService = "";
    let profileTvService = "";
    let profileVoiceService = "";

    if (InHomeUtils.isNotNull(profileInfo.cartData) && InHomeUtils.isNotNull(profileInfo.cartData[0]) && InHomeUtils.isNotNull(profileInfo.cartData[0].serviceHeaders)) {
        profileInfo.cartData[0].serviceHeaders.servicehead.map((svcObj) => {
            if (svcObj.prodType === "BASIC") {
                profileTvService = svcObj.prodTypeVal;
            }

            if (svcObj.prodType === "FTTPD") {
                profileDataService = svcObj.prodName;
            }
            if (svcObj.prodType === "FVPRIMARY") {
                profileVoiceService = svcObj.prodName;
            }

        });
    }

    sCustomerType = "eofphone" + profileVoiceService + "-" + "eofios " + profileDataService + "-" + "eofios tv " + profileTvService;

    return sCustomerType;
}

export const updateLQZip = (zip) =>{
    vzdl.page.LQZip = zip;
}

export const vzdlSystemfailure = async (zip="", errMssg = "",addrID= "")=>{
    let hashedAddressVal = vzdl.user.prospect;
    hashedAddressVal = '';
    if(hashedAddressVal === '' && addrID !== ""){
        const locusID = (addrID + shaKey);
        try {
            const msgUint8 = new TextEncoder().encode(locusID);                          // encode as (utf-8) Uint8Array
            const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);          // hash the message
            const hashArray = Array.from(new Uint8Array(hashBuffer));                    // convert buffer to byte array
            hashedAddressVal = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
        } catch (error) {
            console.error("getSHA-256 failed", error);
        }
    }
    vztag.api.dispatch("loopQual",{
        version : 2,
        type : "system failure",
        zip : zip,
        hashedAddress : hashedAddressVal,
        errorMessage : errMssg, // (for system failure errors only) // To be kept blank
        data : {
            page: {
                flow : "lq widget",
                detail : "server error" // e.g. server error }
            },
            target : {
                engagement : { intent : "Ordering" }
            }
        }
    })
}

export const saveTheSaleDataApiCall = (isClassicFlow, pageName = "buildproducts") =>{

    const savethesaleObj = {
        name :  "Complete your order",  
        selector : "Complete your order",         
        data : {
           page: {
                name: pageName,
                flow: `prospect accord + ${isClassicFlow ? "classic": "mix match"}`,
                subFlow: "byob",               
                sourceChannel: "VZF",
                detail: "complete your order",
            },
            target: {
                engagement: {
                    intent: "Ordering"
                }
            }
       }
    };
    // vztag?.api.dispatch("sendData", {
    //     name :  "Complete your order",  
    //     selector : "Complete your order",         
    //     data : {
    //        page: {
    //             name: "buildproducts",
    //             flow: `prospect accord + ${isClassicFlow ? "classic": "mix match"}`,
    //             subFlow: "byob",               
    //             sourceChannel: "VZF",
    //             detail: "complete your order",
    //         },
    //         target: {
    //             engagement: {
    //                 intent: "Ordering"
    //             }
    //         }
    //    }
    //     })

        // window.vzdl = savethesaleObj.data;
        if (window.VZTAG_IS_READY) {
          window.vztag.api.dispatch('sendData', savethesaleObj);
        } else {
          document.addEventListener(
            'vztagReady',
            (function vztagApi(VapiName, Vobj) {
              return () => {
                window.vztag.api.dispatch(VapiName, Vobj);
              };
            })('sendData', savethesaleObj),
          );
        }
}

export const passiveLQScall = () => {
   
    vztag.api.dispatch("sendData", {
        name :  "passive lq",           
        data : {
           page: {
                flow: "lq widget",
                subFlow: "plq",               
                channel: "Ordering",
                detail: 'plq result -single fios eligible',
            },
            user: {
                authStatus: "anonymous/logged in",
                accountType: "new customer",
                productsQualified:'single-fdata',
            },
            discount_mh_ec: false,
            discount_mh_nc: false,
            event: {
                value: "event334"
            },
            target: {
                engagement: {
                    intent: "Ordering"
                }
            }
        
       }
        })
}

var retrySendCustomEventCount = 0;
const sendCustomEvent = (evt) => {
    retrySendCustomEventCount = 0;
    if(targetMessageFlag){
        targetMessageFlag  = false;
    }
    else{
        vzdl.target.message = '';
    }
    //console.log(vzdl.txn.product.current,'product current')
    if (window.dtm_doplugins && vzdl && vzdl.page && vzdl.page.name) {
        if (document.createEvent && document.body.dispatchEvent) {
            //var event = document.createEvent('Event');
            //event.initEvent(evt, true, true);
            var event = new Event(evt);
            document.body.dispatchEvent(event);
         } 
        //else if (window.CustomEvent && document.body.dispatchEvent) {
        //     var ev = new CustomEvent(evt, {
        //         bubbles: true,
        //         cancelable: true
        //     });
        //     document.body.dispatchEvent(ev);
        // }
    }
    else {
        setTimeout(() => { retrySendCustomEvent(evt); }, 500);
    }
}

// function debounce(func, timeout = 300){
//     let timer;
//     return (...args) => {
//       clearTimeout(timer);
//       timer = setTimeout(() => { func.apply(this, args); }, timeout);
//       console.log("debounce called");
//     };
//   }

  //const sendCustomEvent = debounce(() => sendCustomEventDebounce());

const retrySendCustomEvent = (evt) => {
    retrySendCustomEventCount = retrySendCustomEventCount++;
    if (window.dtm_doplugins) {
        sendCustomEvent(evt);
    } else if (retrySendCustomEventCount < 5) {
        setTimeout(() => { retrySendCustomEvent(evt); }, 500);
    }
}

const getprdCategoryInfoSupp = (tmpprodType, prdobj) => {
    let val = tmpprodType;

    if (tempVzdlSCData.profileProduct.length > 0) {
        let isprofileprdMatch = false;
        for (var i = 0; i < tempVzdlSCData.profileProduct.length; i++) {
            if (tempVzdlSCData.profileProduct[i].prodId === prdobj.prodId) {
                isprofileprdMatch = true;
                break;
            }
        }
        if (!isprofileprdMatch) {
            tempVzdlSCData.profileProduct.map((tmpprofileObj) => {
                if (prdobj.prodId !== tmpprofileObj.prodId && prdobj.prodType === tmpprofileObj.prodType) {
                    switch (prdobj.prodType) {
                        case "BASIC":
                            val = "Supp TV Change " + tmpprofileObj.prodName + "to " + prdobj.prodName;
                            break;
                        case "FTTPD":
                            val = "Supp INET Change " + tmpprofileObj.prodName + "to " + prdobj.prodName;
                            break;
                        case "VROOM":
                        case "VFEATURE":
                            val = "supp add FTV Equip";
                            break;

                        default:
                            break;
                    }

                }
            });
        }
    }

    return val;
}



export const VzdlCartProdEvents = (visitId, product, prodType, response, isDoFlow, isPrdAddEvent, upsellInfo = null, flowType, isFCPflow, eventAction) => {
    try {
        vzdl.txn.product.current = [];
        //let cartHeaders = getCartHeader(visitId, product, prodType, response, isDoFlow, isPrdAddEvent, upsellInfo = null, flowType, isFCPflow);
        let cartProducts = getCartProducts(visitId, product, prodType, response, isDoFlow, isPrdAddEvent, upsellInfo = null, flowType, isFCPflow);
        if (InHomeUtils.isNotNull(cartProducts)) {
            for (let cartprod = 0; cartprod < cartProducts.length; cartprod++) {
                vzdl.txn.product.current.push(getProductsFromCartArray(cartProducts[cartprod]))
            }
        }
        console.log("eventaction", eventAction, prodType)
        vzdl.event.value = (eventAction == "AddtoCart" ? prodType !="INTERNET" ? "scAdd,scOpen" : "scAdd" : "scRemove");
        //tempVzdlSCData.events = (eventAction == "AddtoCart" ? "scAdd,scOpen" : "scRemove");
        

        if (flowType === "MV" || InHomeUtils.isFlowTypeCheckMoves()) {
            tempVzdlSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
            if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow && !InHomeUtils.flowCheckforSeamless() && !InHomeUtils.isFCPInProfile()) {
                tempVzdlSCData.flowName = "accord move + mix match";
            }
            else if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow && InHomeUtils.flowCheckforSeamless() && InHomeUtils.isFCPInProfile()) {
                tempVzdlSCData.flowName = "accord seamless move";
            }
            else if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow && InHomeUtils.flowCheckforSeamless() && !InHomeUtils.isFCPInProfile()) {
                tempVzdlSCData.flowName = "accord seamless move + mix match";
            }
            else {
                tempVzdlSCData.flowName = "accord move";
            }            
            updateVzdlSCCustomEvent("cartAddServiceMoves", eventAction, "detailPageName,name,contentChannel")
        }
        else {
            if (flowType === "SUPP") {
                updateVzdlSCCustomEvent("cartAddServiceSupp", eventAction, "");                
            }
            else {
                updateVzdlSCCustomEvent("cartAddService", eventAction, "detailPageName,name,events");                
            }
        }
    }
    catch (ex) {
        console.log("VzdlAddToCartSCEvent" + ex.message);
        catchJSException('DTMTag', visitId, 'VzdlAddToCartSCEvent', ex);
    }

}

const getPrdName = (product, flowType) => {
    let val = product.name && product.name === "DVR" ? "DVR Service" : product.name && product.name.replace(/&amp;/g, "and");
    let productNameObj = {
        wifiPLusRouter: "Whole-Home Wi-Fi Plus (Verizon Router Included)",
        custProvRouter: "Customer Provided Router",
        gatewayRouter : "Fios Quantum Gateway Router",
        notPublishedService: "Non Published Service",
        listedPublishedService: "Listed and Published",
        customTv : "Custom TV",
        buy : "Buy",
        visaPrepaidCard : "Visa Prepaid Card",
        prePaidRewardCard : "Prepaid Reward Card",
        internetOffer : "Internet offer: ",
        fvdoSuppAdded : "FVDO+ supp added-",
        fvdoSuppDeleted : " FVDO+ supp deleted-",
        changeRouterSupp : "supp change router "

    }
    if (product?.prodType?.indexOf("ROUTER") > -1) {
        if(product.name === "Whole-Home Wi-Fi Plus (Verizon Router Included)")
            val = productNameObj.wifiPLusRouter;
        else if (product?.prodTypeValue.indexOf("CUSTOMER_PROVIDED") > -1)
            val = productNameObj.custProvRouter;
        else {
            val = (product.prodType.indexOf("NRC") > -1 ? productNameObj.buy : "") + productNameObj.gatewayRouter;
        }
    }
    else {
        if (product.prodType === "FVNONPUB") {
            val = productNameObj.notPublishedService;
        }
        else if (product.prodType === "FVLISTMAIN") {
            val = productNameObj.listedPublishedService;
        }
        else if (product.prodType === "BASIC") {
            val = productNameObj.customTv + val;
        }
        else if (product.prodType === Service.streamDevCount) {
            val = product.OriginalName;
        }
        else if (product.prodType === 'SPLOFFER') {
            let isOfferPrepaid = false;
            if (product.OfferText && product.OfferText.indexOf("Visa Prepaid Card") > -1) {
                val = product.OfferText.replace(productNameObj.visaPrepaidCard, productNameObj.prePaidRewardCard);
                isOfferPrepaid = true;
            }
            if (product.offerFor && product.offerFor.toLowerCase() === "data" && product.OfferText.indexOf("Internet offer") === -1) {
                if (isOfferPrepaid) {
                    val = productNameObj.internetOffer + val;
                } else {
                    val = productNameObj.internetOffer + product.OfferText;
                }
            } else {
                val = product.OfferText;
            }
        }
    }

    if (flowType === "SUPP") {
        if (tempVzdlSCData.profileProduct.length > 0) {
            let isprofileprdMatch = false;
            for (var i = 0; i < tempVzdlSCData.profileProduct.length; i++) {
                if (tempVzdlSCData.profileProduct[i].prodId === product.id) {
                    isprofileprdMatch = true;
                    break;
                }
            }
            if (!isprofileprdMatch) {
                tempVzdlSCData.profileProduct.map((tmpprofileObj) => {
                    if (product.id !== tmpprofileObj.prodId && product.prodType === tmpprofileObj.prodType) {
                        if (product.prodType === "VROOM" || product.prodType === "VFEATURE") {
                            val = productNameObj.fvdoSuppAdded + val + productNameObj.fvdoSuppDeleted + tmpprofileObj.prodName;
                        }

                    }
                    else if (product.id !== tmpprofileObj.prodId && InHomeUtils.isNotNull(product.prodType) && product.prodType.indexOf("ROUTER") > -1
                        && InHomeUtils.isNotNull(tmpprofileObj.prodType) && tmpprofileObj.prodType.indexOf("ROUTER") > -1 && product.prodType !== tmpprofileObj.prodType) {
                        //console.log("router changed");
                        val = productNameObj.changeRouterSupp + tmpprofileObj.prodName + " to supp " + val;
                    }
                });
            }
        }
    }

    return val;
}



export const tempVzdlSCData = {
    name: "",
    detail: "",
    contentFragments: "",
    events: "",
    statePostLQA: "",
    servicePostalCode: "",
    flowName: "",
    bundleSelected: "",
    depositAmount: "",
    installOptions: "",
    MON: "",
    serviceDMA: "",
    newnewRepeatXP1: "",
    creditCheck: "",
    creditCheckstatus: "",
    customerCategory: "",
    isMixMatch: false,
    profileProduct: [],
    IONTEligible: false,
    isSUPPflow: false,
    isDTMCallCompleted: false,
    autoPay: "",
    TwsTransactionID: "",
    UNID: "",
    Startdatetimestamp: "",
    Enddatetimestamp: "",
    Status: "",
    Vendor: "",
    TWSsegment: "",
    TWSsubgroup: "",
    abTest: "",
    prdQualified:"",
};

const getFlowName = (stateInfo, pageInfo, flowName) => {
    let sFlowName = flowName;

    if (InHomeUtils.isNotNull(pageInfo)) {
        if (pageInfo === "nonSeamlessMoves" || pageInfo === "buildFiosMoves" || (pageInfo === "checkAvaillqInit" && InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "MV")) {
            sFlowName = "accord move";
        }
        else if (pageInfo === "seamlessMoves") {
            sFlowName = "accord seamless move";
        }
        else if (pageInfo === "quickcheckoutInit" || pageInfo === "quickcheckoutsummaryInit")
            sFlowName = sFlowName + " + quick checkout";  
        
        else if (pageInfo === "fiosReferral") {
            sFlowName = "Fios Referral";
        }

        if (pageInfo === "careFlowPageInit" || pageInfo === "entrypointInit")
            sFlowName = "prospect";
    }

    if (InHomeUtils.isNotNull(stateInfo)) {
        if (InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "SUPP") {
            sFlowName = "acrd supp-order";
        }        
        if (InHomeUtils.isNotNull(stateInfo.lqInfo) && (stateInfo.lqInfo.isFCPflow || stateInfo.lqInfo.isFcpInProfile)) {
            sFlowName = sFlowName + " + mix match";
        }
        if (InHomeUtils.isNotNull(stateInfo.lqInfo) && (stateInfo.lqInfo.lqResponse.hoaFlag === "Y")) {
            sFlowName = sFlowName + " + vvp";
        }
        if (InHomeUtils.isNotNull(stateInfo.appInfo) && InHomeUtils.isNotNull(stateInfo.appInfo.vendor)
            && InHomeUtils.isNotEmpty(stateInfo.appInfo.vendor.vendorName)) {
            if (stateInfo.appInfo.vendor.vendorName === "RedVentures") {
                sFlowName = sFlowName + " + rv";
            }
            else if (stateInfo.appInfo.vendor.vendorName === "Clearlink") {
                sFlowName = sFlowName + " + cl";
            }
            else if (stateInfo.appInfo.vendor.vendorName === "Target") {
                sFlowName = sFlowName + " + target";
            }
            else if (stateInfo.appInfo.vendor.vendorName === "Quology") {
                sFlowName = sFlowName + " + Qo";
            }
            else {
                sFlowName = sFlowName + " + " + stateInfo.appInfo.vendor.vendorName;
            }
        }

        if (InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "MV") {
            if ((InHomeUtils.isNotNull(stateInfo.cartInfo) && stateInfo.cartInfo.cartOrderProperty === "SEAMLESS")
                || (InHomeUtils.isNotNull(stateInfo?.movesInfo?.movesEligibility) && (stateInfo?.movesInfo?.movesEligibility === "SEAMLESS")) || (window.location.href.indexOf('moves/landing') > -1) || ((InHomeUtils.isNotNull(stateInfo?.appInfo?.movesEligibility) && (stateInfo?.appInfo?.movesEligibility === "SEAMLESS")))) {
                
                // CETC-143221 - Fixes
                if((InHomeUtils.isNotNull(stateInfo?.movesInfo?.movesEligibility) && (stateInfo?.movesInfo?.movesEligibility === "SEAMLESS"))||(InHomeUtils.isNotNull(stateInfo?.appInfo?.movesEligibility) && (stateInfo?.appInfo?.movesEligibility === "SEAMLESS"))){
                    sFlowName = "accord seamless move";
                }
                else{
                  sFlowName = "accord move";
                }
            }
            else {
                sFlowName = "accord move";
            }

            if ((InHomeUtils.isNotNull(stateInfo.lqInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo.isFCPflow) && stateInfo.lqInfo.isFCPflow)) {
                sFlowName = sFlowName + " + mix match";
            }
        }
    }
    return sFlowName;
}

export const scVzdlDataDetails = {
    mHauthentication  : { name: "authentication - tokenized email page", detail: "verification link model", subFlow: 'byob| seq mh' },

    MnHEligible: { name: "out of franchise", detail: "street address oof", contentChannel: "/vz/residential/order/prospect/lqfull", events: "event56" },

    disconnect: { name: "disconnect", detail: "atom| accord| disconnect| disconnect date", events: "event5, event20" },
    tvRecommender: { name: "TVRecommender", detail: "TVRecommender", events: "" },

    depositLoad: { name: "checkout", detail: "install tos and summary - deposit new", events: "" },
    tosLoad: { name: "checkout", detail: "Terms of service", events: "" },

    lofLoad: { name: "order confirmation", detail: "lof| olo registration offered ", events: "", contentChannel: "/vz/residential/order/prospect accord/confirmation" },

    lboInit: { name: "lbo", detail: "", events: "event5,event21", flowName: "prospect accord", contentChannel: "/vz/residential/order/prospect accord/error" },
    ruralLboInit: { name: "lbo redesign", detail: "lbo ruralbroadband", events: "", flowName: "prospect accord", contentChannel: "/vz/residential/order/prospect accord/error" },
    careFlowPageInit: { name: "affinity eligibility info", detail: "affinity eligibility info", events: "", flowName: "prospect", contentChannel: "/vz/residential/order/affinity/" },
    entrypointInit: { name: "entrypoint", detail: "entrypoint", events: "", flowName: "prospect", contentChannel: "" },

    getOrderDetailInit: { name: "retrieve order info", detail: "retrieve your order info", events: "event101", contentChannel: "" },
    pendingOrder: { name: "pendingorder", detail: "pendingOrder", events: "" },

    //overlays events //updated popularPlans text for fixing this issue ITT-691132
    faq: { name: "buildproducts", detail: "faq", events: "prodView", contentChannel: "/vz/residential/order/prospect/faq", flowName: "prospect accord + mix match" },
    popularPlans: { name: "popular plans", detail: "popular plans", events: "" },
    rafRedeemLoad: { name: "buildproducts", detail: "Redeem now", events: "prodView", contentChannel: "/vz/residential/order/prospect accord/select" },
    rafRedeemOrderSummaryLoad: { name: "Interstitial Order Summary Page", detail: "Redeem now", events: "prodView", contentChannel: "/vz/residential/order/prospect accord/select" },
    ffRedeemLoad: { name: "buildproducts", detail: "Redeem now", events: "prodView", contentChannel: "/vz/residential/order/prospect accord/select" },
    ffRedeemOrderSummaryLoad: { name: "Interstitial Order Summary Page", detail: "Redeem now", events: "prodView", contentChannel: "/vz/residential/order/prospect accord/select" },
    vzcRedeemLoad: { name: "buildproducts", detail: "Redeem now", events: "prodView", contentChannel: "/vz/residential/order/prospect accord/select" },
    vzcRedeemOrderSummaryLoad: { name: "Interstitial Order Summary Page", detail: "Redeem now", events: "prodView", contentChannel: "/vz/residential/order/prospect accord/select" },

    blackfridayOfferOverlay: { name: "buildproducts", detail: "blackfriday overlay", events: "prodView", contentChannel: "/vz/residential/order/prospect accord/select" },
    //qualification events 
    flowInitiated: { name: "qualification", detail: "lq check avail", events: "event117" },
    qualificationAttempts: { name: "qualification", detail: "lq check avail", contentChannel: "/vz/residential/order/prospect/lqfull", events: "event137,event160" },
    LQS: { name: "buildproducts", detail: "my order", events: "event117" },
    outOfFranchise: { name: "qualification", detail: "outofFranchise", events: "event137" },
    existingSrvc: { name: "qualification", detail: "existing service", events: "", contentChannel: "/vz/residential/order/prospect/lqfull" },
    addrVerification: { name: "lq address verification", detail: "lq address verification", events: "event5, event8" },
    help: { name: "lq help", detail: "lq help", events: "", contentChannel: "/vz/residential/order/prospect/lqfull" },
    checkAvaillqInit: { name: "qualification", detail: "", contentChannel: "/vz/residential/order/prospect/lqfull", events: "" },
    multipleAddress: { name: "lq multiple address", detail: "lq multiple address", contentChannel: "/vz/residential/order/prospect/lqfull", events: "" },
    //buildproducts events
    buildFiosInit: { name: tempPageName, detail: "", contentChannel: "/vz/residential/order/prospect accord/select", events: "" },
    prodView: { name: tempPageName, detail: 'buildproducts', contentChannel: "/vz/residential/order/prospect accord/select", events: "prodView" },
    accordionOpen: { name: tempPageName, detail: "internet", events: "", contentChannel: "/vz/residential/order/prospect accord/select" },
    cartAddService: { name: tempPageName, detail: "", events: "scAdd", bundleSelected: "", contentChannel: "/vz/residential/order/prospect accord/select" },
    cartAddService15G: { name: tempPageName, detail: "", events: "scAdd", bundleSelected: "", contentChannel: "/vz/residential/order/prospect accord/select" },
    winBackLoad: { name: tempPageName, detail: "phone winback", events: "", contentChannel: "/vz/residential/order/prospect accord/select" },
    winBackPage: { name: tempPageName, detail: "phone winback", events: "", contentChannel: "/vz/residential/order/prospect accord/select" },
    IntelPackLoad: { pageName: "byob", detailPageName: "byob", events: "event5,event15,event20,event46", contentChannel: "/vz/residential/order/prospect accord/select" },
    emergencyServices: { name: tempPageName, detail: "Emergency Services", contentChannel: "/vz/residential/order/prospect accord/select", events: "event117", subFlow: "Emergency Services" },
    mnhModalOverlay:{name: tempPageName, detail:"Mobile + Home Overlay"},

    //checkout events 
    paperfreeBilling: { name: "checkout", detail: "paperfreeBilling", events: "event78" },
    checkoutInit: { name: "checkout", detail: "info and credit - billinfo", events: "", contentChannel: "/vz/residential/order/prospect accord/checkout" },
    checkoutInitIndex: { name: "checkout", detail: "info and credit - billinfo", events: "scCheckout", contentChannel: "/vz/residential/order/prospect accord/checkout" },
    pfbandAutoPayLoad: { name: "checkout", detail: "info and credit - autopay and pfb", events: "" },
    pfbandAutoPayLoadReskin: { name: "checkout", detail: "Your Billing preferences", flowName: "prospect accord", events: "", contentFragments:"" },
    installandtosLoad: { name: "checkout", detail: "installation options - self install", events: "" },
    pfbContinue: { name: "checkout", detail: "info and credit - pfb primary email address", events: "" },
    pfbTos: { name: "checkout", detail: "info and credit - pfb tos", events: "" },
    emergencyServicesCheckout: { name: "buildproducts", detail: "Emergency Services", contentChannel: "/vz/residential/order/prospect accord/select", events: "event116", subFlow: "Emergency Services" },
    cartAddServiceCheckout: { name: "checkout", detail: "", events: "", bundleSelected: "", contentChannel: "/vz/residential/order/prospect accord/select" },
    //submitorder events
    flowCompleted: { name: "order confirmation", detail: "order confirmation", events: "purchase,event116" },
    orderReview: { name: "order confirmation", detail: "view order details", contentChannel: "/vz/residential/order/prospect/lqfull", events: "event146" },
    summaryInit: { name: "order confirmation", detail: "order confirmation", events: "purchase", contentChannel: "/vz/residential/order/prospect accord/confirmation" },
    quickcheckoutsummaryInit: { name: "order confirmation", detail: "order confirmation tech equip", events: "event5,event40,event42,event43,event44,event55,purchase", contentChannel: "/vz/residential/order/prospect accord/confirmation" },
    submitOrderEvent: { name: "inhome summary", detail: "order confirmation", events: "purchase" },
    //order summary
    interOrderSum: { name: "Interstitial Order Summary Page", detail: "review your order", events: "" },
    movesInterOrderSum: { name: "Order Summary Interstitial Page - Moves Flow", detail: "review your order", events: "" },
    
    //saveCart Events
    saveInit: { name: "savecart", detail: "", events: "", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    saveProactive: { name: "smart cart save", detail: "", events: "event85", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    savePassive: { name: "smart cart save", detail: "", events: "event85", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    resave: { name: "smart cart resave", detail: "smart cart resave", events: "event85", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    smartSave: { name: "smart cart resume entry options", detail: "", contentChannel: "/vz/residential/order/prospect accord/smart cart", events: "event86", flowName: "prospect accord" },
    smartResumeError: { name: "smart cart resume entry", detail: "smart cart resume entry not available online", events: "event5, event62", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    smartResumeEntry: { name: "smart cart resume entry", detail: "continue your cart", events: "event5, event62", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    xpsEntryInit: { name: "smart cart resume entry", detail: "smart cart resume entry- continue your cart", contentFragments: "/vz/residential/order/prospect accord/smart cart", events: "", flowName: "prospect accord" },
    cartSaved: { name: "buildproducts", detail: "cartSaved", events: "event85", flowName: "prospect accord" },
    resumeSavedCart: { name: "buildproducts", detail: "", events: "", flowName: "prospect accord" },    

    //Cart Events
    cartView: { detail: "cart open", events: "cartView" },

    //LBO
    errorMessages: { name: "LBO", detail: "", events: "event11" },
    upsellInit: { name: "buildproducts", detail: "byob| upsell| internet plan - 400 mbps to  gigabit connection", events: "prodView", flowName: "prospect accord" },

    //Moves Changes
    loginSuccessful: { name: "qualification", detail: "loginSuccessful", events: "", flowName: "accord move" },
    buildFiosMoves: { name: "buildproducts", detail: "", contentChannel: "/vz/residential/order/prospect accord move/select", events: "", flowName: "accord move + mix match" },
    accordionOpenMoves: { name: "buildproducts", detail: "internet", events: "", contentChannel: "/vz/residential/order/prospect accord move/select" },
    checkoutMoves: { name: "checkout", detail: "info and credit - billinfo", events: "scCheckout", contentChannel: "/vz/residential/order/prospect accord seamless move/checkout" },
    checkoutMovesNonSeamless: { name: "checkout", detail: "info and credit - billinfo", events: "scCheckout", contentChannel: "/vz/residential/order/prospect accord move/checkout" },
    summaryMoves: { name: "order confirmation", detail: "order confirmation tech equip", events: "purchase, event116", contentChannel: "/vz/residential/order/prospect accord seamless move/confirmation" },
    nonSeamlessMoves: { name: "moves landing", detail: "moves landing", events: "", contentChannel: "/vz/residential/order/prospect accord move/lqresults" },
    seamlessMoves: { name: "seamless move landing", detail: "seamless move landing", events: "", contentChannel: "/vz/residential/order/prospect accord seamless move/lqresults" },
    checkoutInitMoves: { name: "checkout", detail: "info and credit - billinfo", events: "scCheckout", contentChannel: "/vz/residential/order/prospect accord seamless move/checkout" },
    checkoutInitNonSeamless: { name: "checkout", name: "info and credit", detail: "info and credit - billinfo", events: "scCheckout", contentChannel: "/vz/residential/order/prospect accord move/checkout" },
    cartAddServiceMoves: { name: "buildproducts", detail: "", events: "scAdd", bundleSelected: "", contentChannel: "/vz/residential/order/prospect accord move/select" },
    cartAddServiceMovesCheckout: { name: "checkout", detail: "", events: "", bundleSelected: "", contentChannel: "/vz/residential/order/prospect accord move/select" },

    //SUPP Changes
    cartAddServiceSupp: { name: "buildproducts", detail: "fios accord supp updated order", events: "scAdd", contentChannel: "/vz/residential/order/prospect accord/select" },
    checkoutInitSupp: { name: "checkout", detail: "fios accord supp checkout", events: "", contentChannel: "/vz/residential/myverizon/whats+next/fios/acrd supp order" },
    buildFiosSupp: { name: "buildproducts", detail: "fios accord supp my order", events: "event117", contentChannel: "/vz/residential/myverizon/whats+next/fios/acrd supp order" },
    summaryInitSupp: { name: "order confirmation", detail: "fios accord supp order confirmation", events: "purchase", contentChannel: "/vz/residential/myverizon/whats+next/fios/acrd supp order" },

    //TWS  detail: "tws disc| fios eligible"  changed CXTDT-603194  
    buildTwsInit: { name: "twsdiscount", detail: "tws discount eligible - fios", contentChannel: "/vz/residential/order/prospect accord/select", events: "", flowName: "prospect accord" },
    BussinessOverlay: { name: "lq address verification", detail: "lq address verification - business addr ovrly", events: "prodView", contentChannel: "" },
    //connectionspage
    connectionConfirm: { name: "affinity eligibility confirmation", detail: "ultimate employees eligibility confirmation", flowName: "prospect" },
    connectionEligibility: { name: "affinity eligibility info", detail: "ultimate employees eligibility info", flowName: "prospect" },
    connectionUploadProof: { name: "affinity eligibility info", detail: "affinity eligibility info - upload proof", flowName: "prospect" },
    //fiosreferralPage
    fiosReferral: { name: "Enter Fios Referral", detail: "", flowName: "Fios Referral" },
    //nsipage
    nsiregistrationinit: { name: "Registration Page", detail: "", flowName: "" },
    pfbpfbandAutoPayLoadReskinTos: { name: "Terms & Conditions", detail: "Auto pay & paperfree billing Terms & conditions", flowName: "" },
    seamlessMovesPerksOverlay: { name: "moves landing", detail: "perk recommendations" },
    seamlessMovesPerksOverlayOSI: { name: "Order Summary Interstitial Page - Moves Flow", detail: "perk recommendations" },
}

export const updateVzdlSCTags = (linkName) => {
    try {
        if(vzdl && vzdl.page && vzdl.page.name){
            window.scLinkTrackID && window.scLinkTrackID(linkName);
        }
    } catch (ex) {
        console.log("updateVzdlSCTags" + ex.message);
        catchJSException('LaunchScript', "visitId", 'updateVzdlSCTags', "updateVzdlSCTags : " + ex);
    }
}

export const sendDataEvent = (event)=>{
    vztag.api.dispatch("sendData", {
        name : '',
        events : event
      });
}
export const getIsVZFwdFlag = () =>{
         return  (store && store.getState() && store.getState().buildProduct && store.getState().buildProduct?.isVZFwdFlag) ?? false;
}
export const updateProductAutopayToggle =()=>{
    if(store && store.getState() && store.getState().buildProduct && store.getState().buildProduct?.isAPDataEnabled===false){
        if (vzdl?.txn?.product?.current && Array.isArray(vzdl?.txn?.product?.current))
              vzdl.txn.product.current=vzdl?.txn?.product?.current.filter((item) => item.id != "R4340")
      }
      else{
          let latestCartState =  store && store.getState() && store.getState().cart;
          if (InHomeUtils.isNotNull(latestCartState)
              && InHomeUtils.isNotNull(latestCartState.cartResponse) && InHomeUtils.isNotNull(latestCartState.cartOrderDetail)) {
                let isAutopayAvail = getProductObject(latestCartState.cartOrderDetail, latestCartState.cartResponse, "MV").find((item)=>item.id==="R4340")
                if(!(vzdl?.txn?.product?.current.some(object => object.id === "R4340"))){
                    vzdl?.txn?.product?.current.push(isAutopayAvail)
                  }
                }
      }
}
export const updateVzdlSCCustomEvent = (objName, eventName, updatedTags, otherVzdlObjects = false, abTestValue = "", skipEvent=false, notification = "", currProduct = "", noOfInstallDays = "", detail="", buildProduct = '',contentFragment) => {  
    if (vzdl && vzdl.error && vzdl.error.code !== "") {
        vzdl.error.code = "";
    }
    //VCGBQA-1658 NC Tagging Subflow Added
    if(subflowChange != ''){
        vzdl.page.subFlow = subflowChange;
        subflowChange = '';
    }
    if(eventName === "sendData" && vzdl.page.subFlow!= ''){
        subflowChange = vzdl.page.subFlow
    }
    if (vzdl?.txn?.product?.current && !Array.isArray(vzdl?.txn?.product?.current)) {
        vzdl.txn.product.current = [vzdl?.txn?.product?.current];
    }
    if(contentFragment!==""){
        vzdl.page.contentFragments = contentFragment;
    }
    if(currProduct && currProduct!= ""){
        addProductCurrent(currProduct, buildProduct)
    } else{

        if(isProdView){
            vzdl.txn.product.current = currProductsArray;
            isProdView = false;
        }
    }

    if(objName === 'interOrderSum'){
        let latestCartState =  store && store.getState() && store.getState().cart;
        let flowType = store && store.getState && store.getState().app && store.getState().app.flowType;
        if (InHomeUtils.isNotNull(latestCartState) && InHomeUtils.isNotNull(latestCartState.cartResponse) && InHomeUtils.isNotNull(latestCartState.cartOrderDetail))
        {
            vzdl.txn.product.current = getProductObject(latestCartState.cartOrderDetail, latestCartState.cartResponse, flowType);
        } 
    }
    generateValueBayouCombo();  
    if(noOfInstallDays != ""){
        vzdl.txn.noOfInstallDays = noOfInstallDays;
    }
    else{
        vzdl.txn.noOfInstallDays = '';
    }
    if(updatedTags.indexOf("subflow") > -1){
        if(scVzdlDataDetails[objName]){
            updateSubFlowValue(scVzdlDataDetails[objName].subFlow, scVzdlDataDetails[objName].subFlow);
        }
        let mm3Qualified = (store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.internet && (store.getState().buildProduct.internet.mm3Qualified  || store.getState().buildProduct.mnFromApi)) || (window.sessionStorage?.mm3Qualified === true || window.sessionStorage?.mm3Qualified === "true");
        if(vzdl.page.subFlow != '' && !mm3Qualified){
            // vzdl.page.subFlow += '|classic';
            updateSubFlowValue('|classic','clas')
        }
    }  
    if (scVzdlDataDetails[objName].name !== undefined && scVzdlDataDetails[objName].name !== "" && updatedTags.indexOf("name") === -1) {

        let isVZFwdFlag = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct?.isVZFwdFlag;
        tempVzdlSCData.name = scVzdlDataDetails[objName].name;
    }
    // if (scVzdlDataDetails[objName].detail !== undefined && scVzdlDataDetails[objName].detail !== "" && updatedTags.indexOf("detail") === -1) {
    //     tempVzdlSCData.detail = scVzdlDataDetails[objName].detail
    // }
    if (updatedTags.indexOf("detail") === -1) {
        tempVzdlSCData.detail = scVzdlDataDetails[objName].detail
    }
    else{
        if(detail && detail!=""){
            tempVzdlSCData.detail = detail;
        }
    }
    // if (scVzdlDataDetails[objName].events !== undefined && scVzdlDataDetails[objName].events !== "" && updatedTags.indexOf("events") === -1) {

    //     tempVzdlSCData.events = scVzdlDataDetails[objName].events
    // }
    if (updatedTags.indexOf("events") === -1) {
        if(skipEvent !== true){ // Skip to update event86 in unneccessary places.
            tempVzdlSCData.events = scVzdlDataDetails[objName].events
        }
    }
    // VCGBQA-1466 - changes
    if (updatedTags.indexOf("notification") > -1) {
       vzdl.target.message = notification;
       targetMessageFlag = true;
    }else{
        vzdl.target.message = "";
    }

    if (scVzdlDataDetails[objName].contentFragments !== undefined && scVzdlDataDetails[objName].contentFragments !== "" && updatedTags.indexOf("contentFragments") === -1) {
        tempVzdlSCData.contentFragments = scVzdlDataDetails[objName].contentFragments
    }
    // if (scVzdlDataDetails[objName].flowName !== undefined && scVzdlDataDetails[objName].flowName !== "") {
    //     tempVzdlSCData.flowName = scVzdlDataDetails[objName].flowName
    // }
    if (abTestValue !== "") {
        vzdl.target.abTest = tempVzdlSCData.abTest = abTestValue;
    }

        
    if (scVzdlDataDetails[objName].flowName !== undefined && scVzdlDataDetails[objName].flowName !== "") {
        //VEC Ordering Tagging Issue in Chekcout
        let lqResponse = store && store.getState && store.getState().loopQual && store.getState().loopQual.lqResponse;
        if (lqResponse.hoaFlag === "Y" && scVzdlDataDetails[objName].flowName === "prospect accord") {
            tempVzdlSCData.flowName = "prospect accord + vvp";
        }
        else {
            tempVzdlSCData.flowName = scVzdlDataDetails[objName].flowName;
        }
    }

    if (otherVzdlObjects) {
        vzdlErrorUpdate("", otherVzdlObjects);
    }
    else {
        if (InHomeUtils.isFlowTypeCheckMoves()) {
            const moveExp_Cust = store && store.getState && store.getState().moveExp && store.getState().moveExp.cust_opt;
            const lqStateFCPFlow = store && store.getState && store.getState().loopQual && store.getState().loopQual.isFCPflow;
            // if ((InHomeUtils.isNotNull(moveExp_Cust) && moveExp_Cust === "SEAMLESS") || (window.location.href.indexOf('moves/landing') > -1 && (objName === "faq" || objName === "seamlessMoves"))) {
            //     vzdl.page.flow = "prospect accord + seamless move";
            // }
            // else {
            //     vzdl.page.flow = "accord move";
            // }
            // if ((InHomeUtils.isNotNull(lqStateFCPFlow) && lqStateFCPFlow)) {
            //     vzdl.page.flow = vzdl.page.flow + "| mix match";
            // }
        }
        else {
            if (objName === "BussinessOverlay") {
                //vzdl.page.flow = vzdl.page.flow;
                let lqState = store && store.getState && store.getState().loopQual && store.getState().loopQual;
                if (lqState ?.selectedAdr) {
                    updateVzdlObjectValues("pageView", lqState ?.selectedAdr, "", "", "");
                }
            }
        }
        customEventUpdate(tempVzdlSCData, eventName, objName);
    }
}

export const resetInstallationDays = ()=>{
    vzdl.txn.noOfInstallDays = '';
}

export const updateVzdlObjectValues = (objName, ObjValues, eventName, eventValue, visitId) => {
    try {
        if (objName === "pageView") {
            vzdl.page.LQZip = ObjValues.zip;
            vzdl.user.zip = ObjValues.zip;
            if (window.sessionStorage && window.sessionStorage.LQResponse && InHomeUtils.isNotEmpty(window.sessionStorage.LQResponse)) {
                let locusId = null;
                let ntasAddrID =null; 
                let response = window.sessionStorage.LQResponse;
                var responseObj = JSON.parse(response);
                
                //ACT44-287 - Adding locusid in rtm
                vzdl.utils.rtm.locusId = responseObj && responseObj.output && responseObj.output.addressId ? responseObj.output.addressId : responseObj.output?.subLocationId ? responseObj.output.subLocationId :'' ;                
                //CETC-142921 - From LQresponse we can get the locus id from hashedLocusId
                if(responseObj && responseObj.output && InHomeUtils.isNotEmpty(responseObj.output.hashedLocusId)) {
                    vzdl.user.prospect = responseObj.output.hashedLocusId
                }
                else if (responseObj && responseObj.output && (responseObj.output.addressId || responseObj.output.subLocationId)) {
                    locusId = InHomeUtils.isNotEmpty(responseObj.output.addressId) ? responseObj.output.addressId : InHomeUtils.isNotEmpty(responseObj.output.subLocationId) ? responseObj.output.subLocationId : null;
                    locusId && getSHA256Val(locusId);
                } else if (responseObj && responseObj.output && responseObj.output.fiosResponse && responseObj.output.fiosResponse.postValues && responseObj.output.fiosResponse.postValues.config && responseObj.output.fiosResponse.postValues.config.addressInfo
                    && (responseObj.output.fiosResponse.postValues.config.addressInfo.addressid || responseObj.output.fiosResponse.postValues.config.addressInfo.addressId) && (InHomeUtils.isNotEmpty(responseObj.output.fiosResponse.postValues.config.addressInfo.addressid) || InHomeUtils.isNotEmpty(responseObj.output.fiosResponse.postValues.config.addressInfo.addressId))) {
                    ntasAddrID = responseObj.output.fiosResponse.postValues.config.addressInfo.addressid ? responseObj.output.fiosResponse.postValues.config.addressInfo.addressid : responseObj.output.fiosResponse.postValues.config.addressInfo.addressId;
                    getSHA256Val(ntasAddrID);
                }
            }
            else if (ObjValues ?.addressID || ObjValues ?.ntasAddrID) {
                let valueAddr = ObjValues.addressID ? ObjValues.addressID : ObjValues.ntasAddrID ? ObjValues.ntasAddrID : "null";
                getSHA256Val(valueAddr); //CETC-142921 - fix added
            }
        }
    }
    catch (ex) {
        console.log("updateVzdlObjectValues" + ex.message);
        catchJSException('LaunchScript', visitId, 'updateVzdlObjectValues', "updateVzdlObjectValues : " + ex);
    }
}

export const getSHA256Val = async (item, accountChange = false) => {
    let hashHex = "";
    const locusID = (item + shaKey);
    try {
        const msgUint8 = new TextEncoder().encode(locusID);                          // encode as (utf-8) Uint8Array
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);          // hash the message
        const hashArray = Array.from(new Uint8Array(hashBuffer));                    // convert buffer to byte array
        hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
        if(accountChange){
            accountHashed = hashHex;
            vzdl.user.account = hashHex;
        }
        else{
            vzdl.user.prospect = hashHex;
        }
    } catch (error) {
        console.error("getSHA-256 failed", error);
        if(accountChange){
            vzdl.user.account = hashHex;
        }
        else{
            vzdl.user.prospect = hashHex;
        }
    }
};

export const updateSaveCartEmail = () => {
    let SmartCartState = store.getState().save;
    if(SmartCartState && SmartCartState.saveModalInput && SmartCartState.saveModalInput !== null) {
        vzdl.utils.rtm.prospectEmail = SmartCartState.saveModalInput;
    }
}

export const updatePersonalInfo = () => {
    let checkoutState = store.getState().personalInfo;
    if(checkoutState && checkoutState.contactInfo && checkoutState.contactInfo.eMailId && checkoutState.contactInfo.eMailId !== null) {
        vzdl.utils.rtm.prospectEmail= checkoutState.contactInfo.eMailId;
    }
    if(checkoutState && checkoutState.contactInfo && checkoutState.contactInfo.phoneNo && checkoutState.contactInfo.phoneNo.ph1 && checkoutState.contactInfo.phoneNo.ph1 !== null) {
        vzdl.utils.rtm.mtn = checkoutState.contactInfo.phoneNo.formattedph1;
    }
}

export const updateVZDLPZAIScore = (score,seconds) =>{
    if(vzdl){
        if(vzdl.utils.aiScoreTime === '')
            vzdl.utils.aiScoreTime = score+ '|'+seconds;
        else if(vzdl.utils.aiScoreTime.indexOf(score+ '|'+seconds) !== -1)
            vzdl.utils.aiScoreTime = vzdl.utils.aiScoreTime;
        else {
            vzdl.utils.aiScoreTime = vzdl.utils.aiScoreTime+'|'+score+ '|'+seconds;
        }
    }    

}

export const addToCartVzdlSCEvent = (visitId, product, prodType, response, isDoFlow, isPrdAddEvent, upsellInfo = null, flowType, isFCPflow, eventAction, eventValue, addonProducts, isTagGspeed = false, Mergescevent = "N", defaultProductadded = false, isCheckout = false) => {
    let lqStateZip = store && store?.getState && store?.getState()?.loopQual && store?.getState()?.loopQual?.selectedState?.zip;
    let appState = store && store.getState && store.getState().app;
    let contractType = response && response.data && response.data.orderDetail && response.data.orderDetail.contract && response.data.orderDetail.contract.indexOf("TWOYEAR") > -1 ? "TwoYears" : "MonthToMonth";
    let lqResponse = store && store.getState && store.getState().loopQual && store.getState().loopQual.lqResponse;
    let notification = store && store?.getState && store?.getState()?.buildProduct && store.getState().buildProduct.SweetnerMsg && store.getState().buildProduct.SweetnerMsg.currentMsg.replace(/<strong>|<\/strong>/g, '');
   try {
        let isRemoveFlag = eventAction === "RemovefromCart" ? true : false;
        let displayFullcartData = false;
        let val = "";
        let timer = 0;
        if (flowType == "15G") {
            tempVzdlSCData.events = (eventAction == "AddtoCart" ? "scAdd, scOpen" : "scRemove");
        } else {
            tempVzdlSCData.events = (eventAction == "AddtoCart" ? "scAdd" : "scRemove");
        }
        
        eventAction = "AddtoCart";
        if (prodType === Service.internet || prodType === Service.tv || prodType === Service.voice || (prodType === Service.mm3)) {
            displayFullcartData = true;
        }
        if (InHomeUtils.isNotNull(upsellInfo) && upsellInfo.isUpsell) {
            let isVZFwdFlag = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct?.isVZFwdFlag;
            tempVzdlSCData.name = "buildproducts";
            tempVzdlSCData.detail = upsellInfo.upsellSCTag;
        }
        else {
            // val = isDoFlow ? "do accord" : "buildproducts"
            //tempVzdlSCData.page = val;
            if (prodType === Service.internet ) {
                if(product.name){
                    val = val + "internet - " + product.name
                    }
                    else{
                    val = val + "internet "
                }
            }
            else if (prodType === Service.tv || prodType === Service.customTV) {
                val = val + "tv "
                if (product.prodTypeValue === "Fios_Five") {
                    val = val + "your fios tv";
                }
                else if(InHomeUtils.isNotNull(product.name)){
                    val = product.name?.replace("4.0","") ;
                    // let isSpanishTV = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct?.tv.spanishTV ;
                    // val = isSpanishTV ? "spanish" : "live tv";
                }
            }
            else if (prodType === Service.voice) {
                timer = 1000;
                val = val + "phone"
            }
            else if (prodType === Service.router) {
                if (product.prodTypeValue === "CUSTOMER_PROVIDED_ROUTER") {
                    val = val + "internet select your own router";
                }
                else if(product.name){
                    val = val + product.name;
                }
                else{
                    val = val + "internet customize"
                }
            }
            else if (prodType === Service.techSure) {
                if(product.name){
                    val = val + product.name;
                }
                else{
                    val = val + "internet security and protection";
                }
            }
            else if (prodType === Service.recording || prodType === Service.vRoom || prodType === Service.channel) {
                if(prodType === Service.channel)
                val = val + "premium channels"
                else
                val = val + "tv customize"
            }
            else if (prodType === "WINBACKADDED") {
                val = val + "phone winback current phone number " + (isPrdAddEvent ? "selected" : "removed");
                displayFullcartData = true;
            }
            else if (prodType === Service.listing) {
                val = val + "phone directory listing"
            }
            else if (prodType === Service.battery) {
                val = val + "Add powerReserve"
            }
            else if (prodType === Service.streamServ) {
                val = val + "stream services-devices pick service"
            }
            else if (prodType === Service.streamDev) {
                val = val + "stream services-devices add device"
            }
            else if (prodType === Service.streamDevCount) {
                val = val + "stream services-devices add devices-nums"
            }
            else if (prodType === Service.flashOffer) {
                val = val + "internet black friday "
            }
            else if (prodType === Service.intrnlChnl) {
                val = val + "add international channel"
            }
            else if (prodType === Service.splOffer) {
                // if (InHomeUtils.isNotNull(product)  && ((InHomeUtils.isNotNull(product.BsOfferAttrValue)  && product.BsOfferAttrValue === "DISCOVERYPLUS_3MO")
                // || (InHomeUtils.isNotNull(product.offerAttrValue)  && product.offerAttrValue === "DISCOVERYPLUS_3MO"))) {
                //     val = val + "internet select offer discovery plus details ovrly 3m";
                // }
                // else if (InHomeUtils.isNotNull(product)  && ((InHomeUtils.isNotNull(product.BsOfferAttrValue)  && product.BsOfferAttrValue === "DISCOVERYPLUS_6MO")
                // || (InHomeUtils.isNotNull(product.offerAttrValue)  && product.offerAttrValue === "DISCOVERYPLUS_6MO"))) {
                //     val = val + "internet select offer discovery plus details ovrly 6m";
                // }
                // else if (InHomeUtils.isNotNull(product)  && ((InHomeUtils.isNotNull(product.BsOfferAttrValue)  && product.BsOfferAttrValue === "DISCOVERYPLUS_12MO")
                // || (InHomeUtils.isNotNull(product.offerAttrValue)  && product.offerAttrValue === "DISCOVERYPLUS_12MO"))) {
                //     val = val + "internet select offer discovery plus details ovrly 12m";
                // }
                // else if (InHomeUtils.isNotNull(product)  && ((InHomeUtils.isNotNull(product.BsOfferAttrValue)  && product.BsOfferAttrValue === "SONY_PLAYSTATION")
                // || (InHomeUtils.isNotNull(product.offerAttrValue)  && product.offerAttrValue === "SONY_PLAYSTATION"))) {
                //     val = val + "internet select offer play station details ovrly";
                // }
                // else if (InHomeUtils.isNotNull(product)  && ((InHomeUtils.isNotNull(product.BsOfferAttrValue)  && product.BsOfferAttrValue === "SONY_PLAYSTATION_3MONTH")
                // || (InHomeUtils.isNotNull(product.offerAttrValue)  && product.offerAttrValue === "SONY_PLAYSTATION_3MONTH"))) {
                //     val = val + "internet select offer play station details ovrly";
                // }
                //else {
                if(product && product.OfferText){
                    val = val + product.OfferText;
                }
                else{
                    val = val + "internet select your int promo offer";
                }
                //}
            }
            // tempVzdlSCData.detail = val.split("|")[1].trim(); // for DOflows/Prepaid need to uodate these values later 
            if(InHomeUtils.isNotNull(product.name) && val === ""){
                val = product.name.toLowerCase();
            }
            let taggingServiceType = prodType;
            if (prodType === Service.tv) {
                let buildProductState = store && store.getState && store.getState().buildProduct;
                taggingServiceType = buildProductState?.tv?.spanishTV ? "SPANISHTV" : "LIVETV";
        
            }
            if(InHomeUtils.isNotNull(ServiceTaggingDetail[taggingServiceType]) && InHomeUtils.isNotEmpty(ServiceTaggingDetail[taggingServiceType])) {
                val = ServiceTaggingDetail[taggingServiceType]
            }
            tempVzdlSCData.detail = val;
        }

        let srvcsOrdered = (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.orderDetail) && InHomeUtils.isNotNull(response.data.orderDetail.servicesOrdered)) ? response.data.orderDetail.servicesOrdered.replace("DATA", "fdata").replace("VIDEO", "ftv").replace("FIOS_VOICE", "fphone") : "";
        let prdArray = []
        let srvcsVal = ""
        if (srvcsOrdered !== "") {
            let srvcs = srvcsOrdered.split(',');
            if (srvcs.length === 3) {
                srvcsVal = "triple - "
            }
            else if (srvcs.length === 2) {
                srvcsVal = "double - "
            }
            else {
                srvcsVal = "single - "
            }
            srvcsVal = srvcsVal + srvcsOrdered.replace(/,/g, "|");
        }
        // if (displayFullcartData) {
        //     vzdl.user.productsQualified = srvcsVal;
        // }
        if (prodType !== "INITCHECKOUTDATA") {
            tempVzdlSCData.bundleSelected = srvcsVal;
        }
        if (InHomeUtils.isNotNull(upsellInfo) && upsellInfo.isUpsell) {
            upsellInfo.upsellProducts.map(product => {
                prdArray.push({
                    // "productID": product.name,
                    // "discountID": "",
                    // "productNumber": product.id,
                    // "primaryCategoryandSub": product.prodType === "PPP" ? getVasCategory(product) : prdCategoryInfo(product.prodType, flowType, product),
                    // "priceBase": calcprdBasePrice(product),
                    // "priceDiscount": "0",
                    // "quantity": "1",
                    // "priceRecurring": InHomeUtils.isNotNull(product.displayPrice) ? product.displayPrice.replace("$", "") : "0"
                    "name": product.name,
                    "id": product.id,
                    "merchCat": "",
                    "category": product.prodType === "PPP" ? getVasCategory(product) : prdCategoryInfo(product.prodType, flowType, product),
                    "offer": "",
                    "discount": "",
                    "qty": "1",
                    "recurringPrice": InHomeUtils.isNotNull(product.displayPrice) ? product.displayPrice.replace("$", "") : "0",
                    "nonRecurringPrice": "",
                    "line": "",
                    "sku": "",
                    "contractType": contractType,
                    "shippingCharge": "",
                    "shippingType": "",
                    "shared": "",
                    "orderType": InHomeUtils.isNotNull(vzdl.txn) && InHomeUtils.isNotNull(vzdl.txn.orderType) ? vzdl.txn.orderType : ""

                });
                return prdArray;
            })
        }
        else {
            if (prodType === Service.channel) {

                response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection.map(obj => {
                    if (obj.sectionType === "CHANNEL") { // This is premium pack addition to DTM Tag 
                        // prdArray.push({
                        //     "productID": (flowType === "SUPP" ? "FVDO+ supp added-" : "") + product.name.replace(/&reg;/g, ""),
                        //     "discountID": "",
                        //     "productNumber": product.id, // Currently dont have USOC in cart response .. Need to change in service level
                        //     "primaryCategoryandSub": prdCategoryInfo(product.prodType, flowType, product),//obj.title, // Currently dont have prodType  in cart response .. Need to change in service level
                        //     "priceBase": InHomeUtils.isNotNull(product.displayPrice) ? product.displayPrice.replace("$", "") : (InHomeUtils.isNotNull(product.originalPrice) ? product.originalPrice.replace("$", "") : "0"),
                        //     "priceRecurring": InHomeUtils.isNotNull(product.displayPrice) ? product.displayPrice.replace("$", "") : (InHomeUtils.isNotNull(product.originalPrice) ? product.originalPrice.replace("$", "") : "0"),
                        //     "quantity": "1",
                        // });
                        prdArray.push({

                            "name": product.name,
                            "id": (flowType === "SUPP" ? "FVDO+ supp added-" : "") + product.name.replace(/&reg;/g, ""),
                            "merchCat": "",
                            "category": product.prodType === "PPP" ? getVasCategory(product) : prdCategoryInfo(product.prodType, flowType, product),
                            "offer": "",
                            "discount": "",
                            "qty": "1",
                            "recurringPrice": InHomeUtils.isNotNull(product.displayPrice) ? product.displayPrice.replace("$", "") : (InHomeUtils.isNotNull(product.originalPrice) ? product.originalPrice.replace("$", "") : "0"),
                            "nonRecurringPrice": InHomeUtils.isNotNull(product.displayPrice) ? product.displayPrice.replace("$", "") : (InHomeUtils.isNotNull(product.originalPrice) ? product.originalPrice.replace("$", "") : "0"),
                            "line": "",
                            "sku": "",
                            "contractType": contractType,
                            "shippingCharge": "",
                            "shippingType": "",
                            "shared": "",
                            "orderType": InHomeUtils.isNotNull(vzdl.txn) && InHomeUtils.isNotNull(vzdl.txn.orderType) ? vzdl.txn.orderType : ""

                        });

                        // prdArray.push({
                        //     "productID": (flowType === "SUPP" ? "FVDO+ supp added-" : "") + obj.title,
                        //     "discountID": "",
                        //     "productNumber": obj.chnlPackId, // Currently dont have USOC for premium pack in cart response .. Need to change in service level                        
                        //     "priceBase": InHomeUtils.isNotNull(obj.sectionTotalprice) ? obj.sectionTotalprice.replace("$", "") : "0",
                        //     "priceRecurring": InHomeUtils.isNotNull(obj.sectionTotalprice) ? obj.sectionTotalprice.replace("$", "") : "0",
                        //     "quantity": "1",
                        // });

                        let merchCategory = product.prodType === "PPP" ? getVasCategory(product) : prdCategoryInfo(product.prodType, flowType, product);
                        prdArray.push({

                            "name": product.name,
                            "id": (flowType === "SUPP" ? "FVDO+ supp added-" : "") + obj.title,
                            'merchCat': merchCategory?.indexOf('FTTP') != -1 ?  'plan' : merchCategory?.indexOf('BYOPERK') != -1 ? 'perk' : merchCategory?.indexOf('ROUTER') != -1 ? "accessories" : "", 
                            "category": merchCategory,
                            "offer": "",
                            "discount": "",
                            "qty": "1",
                            "recurringPrice": InHomeUtils.isNotNull(obj.sectionTotalprice) ? obj.sectionTotalprice.replace("$", "") : "0",
                            "nonRecurringPrice": InHomeUtils.isNotNull(obj.sectionTotalprice) ? obj.sectionTotalprice.replace("$", "") : "0",
                            "line": "",
                            "sku": "",
                            "contractType": contractType,
                            "shippingCharge": "",
                            "shippingType": "",
                            "shared": "",
                            "orderType": InHomeUtils.isNotNull(vzdl.txn) && InHomeUtils.isNotNull(vzdl.txn.orderType) ? vzdl.txn.orderType : ""

                        });



                    }
                    return prdArray;
                })
            }
            else {
                if ((displayFullcartData || !isPrdAddEvent) && !isRemoveFlag ) {
                    prdArray = getProductObject(response.data.orderDetail, response.data.cartTierPricing, flowType, prodType)
                    generateValueBayouCombo();  
                }
                else if (InHomeUtils.isNotNull(product)) {
                    if (prodType === Service.flashOffer) {
                        prdArray.push({
                            // "productID": product.OfferText,
                            // "discountID": product.OfferText,
                            // "productNumber": product.id,
                            // "primaryCategoryandSub": "DISCOUNT",//product.offerAttrValue,
                            // "priceDiscount": "0",
                            // "priceRecurring": "0",
                            // "priceBase": "0",
                            // "type": product.BsOfferAttr,
                            // "quantity": "1",

                            "name": product.id,
                            "id": "",
                            "merchCat": "",
                            "category": "DISCOUNT",
                            "discount": product.OfferText,
                            "qty": "1",
                            "recurringPrice": "0",
                            "nonRecurringPrice": "0",
                            "line": "",
                            "sku": "",
                            "contractType": contractType,
                            "shippingCharge": "",
                            "shippingType": "",
                            "shared": "",
                            "orderType": InHomeUtils.isNotNull(vzdl.txn) && InHomeUtils.isNotNull(vzdl.txn.orderType) ? vzdl.txn.orderType : ""
                        })
                    }
                    else {
                        let prodId = '';
                        if (InHomeUtils.isNotNull(product.id))
                            prodId = product.id;
                        else if (InHomeUtils.isNotNull(product.prodId))
                            prodId = product.prodId;
                         

                        let productCategoryType =  product.prodType === "PPP" ? getVasCategory(product) : prdCategoryInfo(product.prodType, flowType, product);
                        prdArray.push({
                            // "productID": getPrdName(product, flowType),
                            // "discountID": "",
                            // "productNumber": product.id,
                            // "primaryCategoryandSub": product.prodType === "PPP" ? getVasCategory(product) : prdCategoryInfo(product.prodType, flowType, product),
                            // "priceBase": calcprdBasePrice(product),
                            // "priceDiscount": "0",
                            // "quantity": (InHomeUtils.isNotNull(product.prodType) && product.prodType === Service.streamDevCount) ? product.unitCount : "1",
                            // //"priceNonRecurring": product.priceType === "NRC" ? (product.displayPrice !== null ? product.displayPrice.replace("$", "") : (product.originalPrice.replace("$", "") !== null ? product.originalPrice.replace("$", "") : "0")) : "0",
                            // "priceRecurring": ((InHomeUtils.isNotNull(product.prodType) && product.prodType.indexOf("NRC") > -1) || (InHomeUtils.isNotNull(product.keyword) && product.keyword.indexOf("FDV_BTRY_CHARGED") > -1)) ? "0" : calcprdBasePrice(product)
                            "name": getPrdName(product, flowType),
                            "id": prodId,
                            'merchCat': productCategoryType?.indexOf('FTTP') != -1 ? 'plan' : productCategoryType?.indexOf('BYOPERK') != -1 ? 'perk' : productCategoryType?.indexOf('ROUTER') != -1 ? "accessories" : "", 
                            "category": productCategoryType,
                            "discount": product.OfferText !== undefined ? product.OfferText : "",
                            "qty": "1",
                            "recurringPrice": ((InHomeUtils.isNotNull(product.prodType) && product.prodType.indexOf("NRC") > -1) || (InHomeUtils.isNotNull(product.keyword) && product.keyword.indexOf("FDV_BTRY_CHARGED") > -1)) ? "0" : calcprdBasePrice(product),
                            "nonRecurringPrice": ((InHomeUtils.isNotNull(product.prodType) && product.prodType.indexOf("NRC") > -1))  ? calcprdBasePrice(product) : "",
                            "line": "",
                            "sku": "",
                            "contractType": contractType,
                            "shippingCharge": "",
                            "shippingType": "",
                            "shared": "",
                            "orderType": InHomeUtils.isNotNull(vzdl.txn) && InHomeUtils.isNotNull(vzdl.txn.orderType) ? vzdl.txn.orderType : ""

                        });
                    }
                }
            }
        }
        let isGigExists = vzdl.txn.product.current && vzdl.txn.product.current.length > 0 && vzdl.txn.product.current[0].name && vzdl.txn.product.current[0].name.toLowerCase().indexOf("gigabit");
        
        if (product.prodType === addonProducts) {
            vzdl.txn.product.current = [...prdArray, ...vzdl.txn.product.current];
        }
        else {
            vzdl.txn.product.current = prdArray;
        }
        generateValueBayouCombo();
        /*if (eventValue === "scRemove") {
            vzdl.txn.product.current = {};
        }*/
        
                 
        // if (Mergescevent != undefined && Mergescevent == "Y") {            
        //     if (vzdl.txn.product.current && vzdl.txn.product.current.length > 0 && gProductArray && gProductArray.length > 0 && gProductArray[0].name.toLowerCase().indexOf("gigabit")) {//spoffer and internet
        //         var splofferexists  = gProductArray.filter(prd =>prd.id === vzdl.txn.product.current[0].id).length > 0;
        //         if(splofferexists)
        //             vzdl.txn.product.current = [];                
        //         if(vzdl.txn.product.current[0].name.toLowerCase().indexOf("offer"))
        //             isTagGspeed = true;
        //     }
        //     if (vzdl.txn.product.current && vzdl.txn.product.current.length > 0 && vzdl.txn.product.current[0].name.toLowerCase().indexOf("router") && gProductArray && gProductArray.length > 0 && gProductArray[0].name.toLowerCase().indexOf("gigabit")) {//router and internet
        //         isTagGspeed = false;
        //     }
        //     vzdl.txn.product.current = [...gProductArray, ...vzdl.txn.product.current];
        //     if (isTagGspeed != undefined && isTagGspeed == true) {
        //         gProductArray = vzdl.txn.product.current
        //     } else {
        //         gProductArray = [];
        //     } 
                       
        // }

        if((prodType === "SPLOFFER" || prodType === "INTERNET" || product.prodType.indexOf("ROUTERBILLER")>-1) && Mergescevent != undefined && Mergescevent == "Y" && (isGigExists > -1 || isTagGspeed)){

             if (vzdl.txn.product.current && vzdl.txn.product.current.length > 0 && gProductArray && gProductArray.length > 0 && gProductArray[0].name.toLowerCase().indexOf("gigabit") > -1) {//spoffer and internet
                var splofferexists  = gProductArray.filter(prd =>prd.id === vzdl.txn.product.current[0].id && prodType === "SPLOFFER").length > 0;
                if(splofferexists ){
                     isTagGspeed = true;
                    vzdl.txn.product.current = []; 
                }               
                // if(vzdl.txn.product.current[0].name.toLowerCase().indexOf("offer"))
                   
            }
            if ( product.prodType.indexOf("ROUTERBILLER")>-1 && gProductArray && gProductArray.length > 0 && gProductArray[0].name.toLowerCase().indexOf("gigabit") > -1) {//router and internet
                isTagGspeed = false;
                vzdl.txn.product.current = [...gProductArray, ...vzdl.txn.product.current];
            }    
            
            if (isTagGspeed != undefined && isTagGspeed) {
                gProductArray = vzdl.txn.product.current
            } else {
                gProductArray = [];
            }  
                           
        }
        // tempVzdlSCData.product = prdArray;

        getVzdltxnObjects(response, lqStateZip, appState);
        if (isFirstCartAdd == true && eventAction == "AddtoCart"){ // ITT-671147
            tempVzdlSCData.events = "scAdd, scOpen"
        }
        else{
          tempVzdlSCData.events = (eventAction == "AddtoCart" ? "scAdd" : "scRemove");
          tempVzdlSCData.events = eventValue;
        }
        isFirstCartAdd = false;
        currProductsArray = vzdl.txn.product.current;

        if (flowType === "MV" || InHomeUtils.isFlowTypeCheckMoves()) {
            tempVzdlSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
            if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow && !InHomeUtils.flowCheckforSeamless() && !InHomeUtils.isFCPInProfile()) {
                if (lqResponse.hoaFlag === "Y") {
                    tempVzdlSCData.flowName = "accord move + mix match + vvp";
                }
                else {
                    tempVzdlSCData.flowName = "accord move + mix match";
                }
            }
            else if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow && InHomeUtils.flowCheckforSeamless() && InHomeUtils.isFCPInProfile()) {
                if (lqResponse.hoaFlag === "Y") {
                    tempVzdlSCData.flowName = "accord seamless move + vvp";
                }
                else {
                    tempVzdlSCData.flowName = "accord seamless move";
                }
            }
            else if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow && InHomeUtils.flowCheckforSeamless() && !InHomeUtils.isFCPInProfile()) {
                if (lqResponse.hoaFlag === "Y") {
                    tempVzdlSCData.flowName = "accord seamless move + mix match + vvp";
                }
                else {
                    tempVzdlSCData.flowName = "accord seamless move + mix match";
                }
            }
            else {
                if (lqResponse.hoaFlag === "Y") {
                    tempVzdlSCData.flowName = "accord move + vvp";
                }
                else {
                    tempVzdlSCData.flowName = "accord move";
                }
            }
            if(isCheckout){
                updateVzdlSCCustomEvent("cartAddServiceMovesCheckout", eventAction, "detail")
            }
            else{
                updateVzdlSCCustomEvent("cartAddServiceMoves", eventAction, "events,detail")
            }            
        }
        else {
            if (flowType === "SUPP") {
                if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow) {
                    tempVzdlSCData.flowName = "prospect accord supp + mix match";
                }
                else {
                    if (lqResponse.hoaFlag === "Y") {
                        tempVzdlSCData.flowName = "prospect accord supp + vvp";
                    } else {
                        tempVzdlSCData.flowName = "prospect accord supp";
                    }
                }
                updateVzdlSCCustomEvent("cartAddServiceSupp", eventAction, "events");
            }
            else if (flowType == "15G") {
                updateVzdlSCCustomEvent("cartAddService15G", eventAction, "");
            }
            else {
                if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow) {
                    tempVzdlSCData.flowName = "prospect accord + mix match";
                }
                else {
                    if (lqResponse.hoaFlag === "Y") {
                        tempVzdlSCData.flowName = "prospect accord + vvp";
                    }
                    else {
                        tempVzdlSCData.flowName = "prospect accord ";
                    }

                }
                if (isTagGspeed == false) {         
                    if(isCheckout){
                        updateVzdlSCCustomEvent("cartAddServiceCheckout", eventAction, "detail");
                    }
                    else{
                        updateVzdlSCCustomEvent("cartAddService", eventAction, "events,detail,notification","","","",notification);                    
                    }                               
                }
            }
        }



    }
    catch (ex) {
        catchJSException('Launch', visitId, 'addToCartVzdlSCEvent', ex);
    }

}
const getVzdltxnObjects = (response, lqStateZip, appState) => {
    try {
        //PRODDEF-39046 - Restricting txn.id to be populated only for order confirmation page
        if(window.location.href.includes('/summary')){
            vzdl.txn.id = appState && appState.mon_no;
        }
        else{
            vzdl.txn.id = "";
        }
        vzdl.txn.taxAmt = 0;
        vzdl.txn.shippingZip = lqStateZip;
        vzdl.txn.discount = "";
        vzdl.txn.cartId = appState && appState.mon_no; // VCGBQA-1465
        if (response.data && response.data.cartTierPricing) {
            vzdl.txn.total = response.data.cartTierPricing.tierContent[0].totalMonthlyPrice === null ?
                0 : response.data.cartTierPricing.tierContent[0].totalMonthlyPrice.replace('$', '');
            vzdl.txn.recurringCharges = response.data.cartTierPricing.tierContent[0].monthlyRcPrice === null ?
                0 : response.data.cartTierPricing.tierContent[0].monthlyRcPrice.replace('$', '');;
            vzdl.txn.nonRecurringCharges = response.data.cartTierPricing.tierContent[0].totalNrcPrice === null ?
                0 : response.data.cartTierPricing.tierContent[0].totalNrcPrice.replace('$', '');
            vzdl.txn.shippingTotal = response.data.cartTierPricing.tierContent[0].totalMonthlyPrice === null ?
                0 : response.data.cartTierPricing.tierContent[0].totalMonthlyPrice.replace('$', '');
        }
        else {
            if (response.data && response.data.date && response.data.date.cartTierPricing) {
                vzdl.txn.total = response.data.date.cartTierPricing.tierContent[0].totalMonthlyPrice === null ?
                    0 : response.data.date.cartTierPricing.tierContent[0].totalMonthlyPrice.replace('$', '');
                vzdl.txn.recurringCharges = response.data.date.cartTierPricing.tierContent[0].monthlyRcPrice === null ?
                    0 : response.data.cartTierPricing.tierContent[0].monthlyRcPrice.replace('$', '');;
                vzdl.txn.nonRecurringCharges = response.data.date.cartTierPricing.tierContent[0].totalNrcPrice === null ?
                    0 : response.data.date.cartTierPricing.tierContent[0].totalNrcPrice.replace('$', '');
                vzdl.txn.shippingTotal = response.data.date.cartTierPricing.tierContent[0].totalMonthlyPrice === null ?
                    0 : response.data.date.cartTierPricing.tierContent[0].totalMonthlyPrice.replace('$', '');
            }
        }
    }
    catch (ex) {
        catchJSException('Launch', appState.visitId, 'getVzdltxnObjects', ex);
    }
}
const getVasCategory = (product) => {
    let val = product.prodType;

    if (product.bundleId !== null)
        val = "VAS+VSBN+FIXD";
    else
        val = "VAS+VSIT+XXXX";

    return val;
}
const prdCategoryInfo = (prodType, flowType, prdobj) => {
    let val = prodType;
    switch (prodType) {
        case 'FTTPD':
            val = "FTTP+DYAC+";
            break;
        case 'BASIC':
            val = "FVDO+CPKG+";
            break;
        case 'FVPRIMARY':
            val = "FVC+NATL+";
            break;
        case 'ROUTERBILLER':
        case 'ROUTERNRCBILLER':
            val = "FCPE+" + prodType;
            break;
        case 'VROOM':
        case 'VFEATURE':
            val = "FVDO+" + prodType;
            break;
        case 'PREMIUM':
            val = "FVDO+APKG+MOVI";
            break;
        case 'FVLISTMAIN':
            val = "FVC+LT1+";
            break;
        case 'FVNONPUB':
            val = "FVC+NP";
            break;
        case 'SLABATTERY':
        case 'DCELLTRAY':
            val = "FVC+BTRY";
            break;
        case 'MRCFEE':
            val = "FVDO+MRCFEE+BROADCAST";
            break;
        default:
            break;
    }

    if (flowType === "SUPP") {
        val = getprdCategoryInfoSupp(val, prdobj)
    }


    return val;
}


const generateValueBayouCombo = () => {
    if(!window.location.href.includes('buildproducts')){
        let isocIds = '';
        let vzdlCartResponse =  store && store.getState() && store.getState()?.cart?.cartResponse;
        
        if (vzdlCartResponse?.tierContent) {
            vzdlCartResponse?.tierContent?.[0]?.sections?.section?.map((cartsections) => {

                if (cartsections.sectionName == "Service" ||  cartsections.sectionName == "Perks") {
                    
                    cartsections.subSections.subSection.map((cartsubsection) => {

                        if (cartsubsection.sectionType == "DATASTANDALONE") {

                            cartsubsection?.products.map((product) => {
                                
                                if ((product.prodType === "FTTPD") && !isocIds.includes(product.prodId) ) {
                                    isocIds = isocIds + product.prodId + '|'
                                }
                            });
                        }
                        else if(cartsubsection.sectionType == "Perks"){
                            cartsubsection?.products.map((product) => {
                                if (!isocIds.includes(product.prodId) ) {
                                    isocIds = isocIds + product.prodId + '|'
                                }
                            });
                        }
                    });
                }
            })
        }
        // updating bayouCombo if the current item is not in cart response
        Array.isArray(vzdl?.txn?.product?.current) && vzdl?.txn?.product?.current?.forEach((currentItem) => {
            let productMerchCat = currentItem?.merchCat;
            if ((['plan', 'perks'].includes(productMerchCat)) && (!isocIds.includes(currentItem.id))) {
                isocIds = isocIds + currentItem.id + '|'
            }
        });
        vzdl.txn.bayouCombo =  isocIds?.substring(0, isocIds?.length - 1) ?? "";
    }
}

 
export const getProductObject = (orderDetail, tierPricing, flowType , specificService = 'none') => {
    let buildState = store && store.getState && store.getState().buildProduct;
    let offersTileData = [...buildState ?.internet ?.m2mPlans, ...buildState ?.tv ?.m2mPlans];
    let isInternetSelected = buildState && buildState.internet && InHomeUtils.isNotEmpty(buildState.internet.selectedProduct);
    let contractType = orderDetail && orderDetail.contract && orderDetail.contract.indexOf("TWOYEAR") > -1 ? "TwoYears" : "MonthToMonth";
    let prdArray = []
    try {

        if (flowType != 'AF') {
            // Currently for Bundle Recurring and Base Price is same as we dont have seperate baseprice in cart JSON. Need to check further from service level - Added code need to deploy
            if (orderDetail.bundle && InHomeUtils.isNotNull(orderDetail.bundleId) && orderDetail.bundleId !== "B0038") {
                prdArray.push({
                    // "productID": tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].title,
                    // "discountID": "",
                    // "productNumber": orderDetail.bundleId,
                    // "primaryCategoryandSub": getBundlecategory(orderDetail), // Currently no Seperatedetails for bundle from JSON.. need to check with Service Team,
                    // "priceBase": InHomeUtils.isNotNull(tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].priceWithoutPromos) ? parseFloat(tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].priceWithoutPromos.replace("$", "")).toFixed(2) : InHomeUtils.isNotNull(tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice) ? tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice.replace("$", "") : "0.00",
                    // "quantity": "1",
                    // "priceRecurring": InHomeUtils.isNotNull(tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice) ? tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice.replace("$", "") : "0.00",
                    // "priceDiscount": "0"


                    // "name": product.name,
                    "name": tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].title,

                    "id": orderDetail.bundleId,
                    "merchCat": "",
                    "category": getBundlecategory(orderDetail), // Currently no Seperatedetails for bundle from JSON.. need to check with Service Team,
                    "offer": "",
                    "discount": "",
                    "qty": "1",
                    "recurringPrice": InHomeUtils.isNotNull(tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice) ? tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice.replace("$", "") : "0.00",
                    "nonRecurringPrice": "",
                    "line": "",
                    "sku": "",
                    "contractType": contractType,
                    "shippingCharge": "",
                    "shippingType": "",
                    "shared": "",
                    "orderType": InHomeUtils.isNotNull(vzdl.txn) && InHomeUtils.isNotNull(vzdl.txn.orderType) ? vzdl.txn.orderType : ""
                });
            }

            //Currently no seperation for BasePrice and DiscountedPrice - need to check with service and update accordingly - added code need to deploy
            if (tierPricing.tierContent[0].sections && tierPricing.tierContent[0].sections.section[0] && tierPricing.tierContent[0].sections.section[0].subSections !== undefined) {
                tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].products.map(obj => {
                    if(specificService === 'none'){
                    if (obj.prodTypeVal !== "FDVADMIN" && obj.prodType !== "BASIC_FF") {
                        prdArray.push(getPrdArrayFromCart(obj, flowType, offersTileData))
                    }
                    }
                    else{
                        if(specificService === Service.internet || specificService === Service.mm3){
                            if(obj.prodType === 'FTTPD'){
                                prdArray.push(getPrdArrayFromCart(obj, flowType, offersTileData))
                            }
                        }
                        else if(specificService === Service.tv){
                            if(obj.prodType === 'BASIC' || obj.prodType === "PREMIUM" || obj.prodType === "MRCFEE"){
                                prdArray.push(getPrdArrayFromCart(obj, flowType, offersTileData))
                            }
                        }
                        else if(specificService === Service.voice){
                            if(obj.prodType === 'FDV' && obj.prodType === 'FVPRIMARY' && obj.prodTypeVal !== "FDVADMIN"){
                                prdArray.push(getPrdArrayFromCart(obj, flowType, offersTileData))
                            }
                        }
                    }
                })
            }

            //Look for other Products like Channel/Equipment/Vroom etc..

            tierPricing.tierContent[0].sections.section.map(secObj => {
                if (secObj.sectionName === "Equipment") {
                    secObj.subSections.subSection.map(subSecObj => {
                        if(specificService === 'none'){
                        if (subSecObj.sectionType === "ROUTER" || subSecObj.sectionType === "SETUPBOX" || subSecObj.sectionType === "RECORDING" || subSecObj.sectionType === "DIGITALADAPTOR") {
                            subSecObj.products.map(obj => {
                                prdArray.push(getPrdArrayFromCart(obj, flowType))
                            })
                        }
                        }
                        else{
                            if(subSecObj.sectionType === "DIGITALADAPTOR"){
                                subSecObj.products.map(obj => {
                                    prdArray.push(getPrdArrayFromCart(obj, flowType))
                                })
                            }
                            if(specificService === Service.internet || specificService === Service.mm3){
                                if (subSecObj.sectionType === "ROUTER") {
                                    subSecObj.products.map(obj => {
                                        prdArray.push(getPrdArrayFromCart(obj, flowType))
                                    })
                                }
                            }
                            else if(specificService === Service.tv){
                                if (subSecObj.sectionType === "SETUPBOX" || subSecObj.sectionType === "RECORDING" || (!isInternetSelected && subSecObj.sectionType === "ROUTER")) {
                                    subSecObj.products.map(obj => {
                                        prdArray.push(getPrdArrayFromCart(obj, flowType))
                                    })
                                }
                            }
                        }
                    })
                }
                if (secObj.sectionName === "Service") {
                    secObj.subSections.subSection.map(subSecObj => {
                        if(specificService === 'none'){
                        if (subSecObj.sectionType === "CHANNEL" || subSecObj.sectionType === "LISTING" || subSecObj.sectionType === "VASSTANDALONE" || subSecObj.sectionType === "STREAMINGSERVICES") {
                            subSecObj.products.map(obj => {
                                prdArray.push(getPrdArrayFromCart(obj, flowType))
                            })
                        }
                        if (subSecObj.sectionType === "TVSTANDALONE") {
                            subSecObj.products.map(obj => {
                                if (obj.prodType === "BASIC_FF") {
                                    prdArray.push(getPrdArrayFromCart(obj, flowType))
                                }
                            })
                        }
                        if (subSecObj.sectionType === "INTLPACKAGE") {
                            subSecObj.products.map(obj => {
                                if (obj.prodType === "INTLPREMIUM") {
                                    prdArray.push(getPrdArrayFromCart(obj, flowType))
                                }
                            })
                        }
                        }
                        else{
                            if(specificService === Service.internet || specificService === Service.mm3){
                                if(subSecObj.sectionType === "VASSTANDALONE"){
                                    subSecObj.products.map(obj => {
                                        prdArray.push(getPrdArrayFromCart(obj, flowType))
                                    })                                }
                            }
                            else if(specificService === Service.tv){
                                if (subSecObj.sectionType === "TVSTANDALONE") {
                                    subSecObj.products.map(obj => {
                                        if (obj.prodType === "BASIC_FF") {
                                            prdArray.push(getPrdArrayFromCart(obj, flowType))
                                        }
                                    })
                                }
                                if (subSecObj.sectionType === "CHANNEL" || subSecObj.sectionType === "STREAMINGSERVICES") {
                                    subSecObj.products.map(obj => {
                                        prdArray.push(getPrdArrayFromCart(obj, flowType))
                                    })
                                }
                                if (subSecObj.sectionType === "INTLPACKAGE") {
                                    subSecObj.products.map(obj => {
                                        if (obj.prodType === "INTLPREMIUM") {
                                            prdArray.push(getPrdArrayFromCart(obj, flowType))
                                        }
                                    })
                                }
                            }
                            else if(specificService === Service.voice){
                                if (subSecObj.sectionType === "LISTING") {
                                    subSecObj.products.map(obj => {
                                        prdArray.push(getPrdArrayFromCart(obj, flowType))
                                    })
                                }
                            }
                        }
                    })
                }

                if (secObj.sectionName === "Onetimecharges") {
                    secObj.subSections.subSection.map(subSecObj => {
                        if(specificService === 'none'){
                        if (subSecObj.sectionType === "BATTERYBACKUP" || subSecObj.sectionType === "ROUTERBUY" || subSecObj.sectionType === "VASSTANDALONE" || subSecObj.sectionType === "SETUPFEE") {
                            subSecObj.products.map(obj => {
                                prdArray.push(getPrdArrayFromCart(obj, flowType));
                            })
                        }
                        }
                        else{
                            if(specificService === Service.internet || specificService === Service.mm3){
                                if (subSecObj.sectionType === "ROUTERBUY" || subSecObj.sectionType === "VASSTANDALONE") {
                                    subSecObj.products.map(obj => {
                                        prdArray.push(getPrdArrayFromCart(obj, flowType));
                                    })
                                }
                            }
                            else if(specificService === Service.tv){
                                if ((!isInternetSelected && subSecObj.sectionType === "ROUTERBUY") || subSecObj.sectionType === "SETUPFEE") {
                                    subSecObj.products.map(obj => {
                                        prdArray.push(getPrdArrayFromCart(obj, flowType));
                                    })
                                }
                            }
                            else if(specificService === Service.voice){
                                if (subSecObj.sectionType === "BATTERYBACKUP") {
                                    subSecObj.products.map(obj => {
                                        prdArray.push(getPrdArrayFromCart(obj, flowType));
                                    })
                                }
                            }
                        }
                    })
                }

                if (secObj.sectionName === "Promotions") {
                    let offerForVal = '';
                    if(specificService === Service.internet || specificService === Service.mm3){
                        offerForVal = "DATA"
                    }
                    else if(specificService === Service.tv){
                        offerForVal = "VIDEO"
                    }
                    else if(specificService === Service.voice){
                        offerForVal = "VOICE"
                    }
                    secObj.subSections.subSection.map(subSecObj => {
                        return (subSecObj.promos.map(obj => {
                            let addToList = false;
                            if(specificService === 'none'){
                                addToList = true;
                            }
                            else if(obj.offerFor && obj.offerFor === offerForVal){
                                addToList = true;
                            }
                            if(addToList){
                            prdArray.push({
                                // "productID": InHomeUtils.isNotEmpty(obj.promoText) && obj.promoText.indexOf('Eligible Customer') > -1 && obj.promoText.indexOf('Mobile + Home Rewards') > -1 ? 'Mobile + Home Rewards Eligible' : obj.promoText,
                                // "discountID": obj.promoText,
                                // "productNumber": obj.promoId,
                                // "primaryCategoryandSub": "DISCOUNT",//obj.offerAttrValue,
                                // "priceDiscount": InHomeUtils.isNotNull(obj.price) ? obj.price : "0",
                                // "priceRecurring": "0",
                                // "priceBase": "0",
                                // "type": obj.offerAttr,
                                // "quantity": "1",

                                "name": InHomeUtils.isNotEmpty(obj.promoText) && obj.promoText.indexOf('Eligible Customer') > -1 && obj.promoText.indexOf('Mobile + Home Rewards') > -1 ? 'Mobile + Home Rewards Eligible' : obj.promoText,
                                "id": obj.promoId,
                                "merchCat": "",
                                "category": "DISCOUNT",
                                "offer": "",
                                "discount": obj.promoText,
                                "qty": "1",
                                "recurringPrice": "0",
                                "nonRecurringPrice": "0",
                                "line": "",
                                "sku": "",
                                "contractType": contractType,
                                "shippingCharge": "",
                                "shippingType": "",
                                "shared": "",
                                "orderType": InHomeUtils.isNotNull(vzdl.txn) && InHomeUtils.isNotNull(vzdl.txn.orderType) ? vzdl.txn.orderType : "" 
                            })
                            }
                        }))
                    })
                }
                //---
                if (secObj?.sectionName === "Perks") {
                    if(specificService === Service.internet || specificService === Service.mm3 || specificService === 'none'){                
                        secObj?.subSections?.subSection?.map((subSecObj) => {
                            return subSecObj?.products?.map(obj => {
                                
                                prdArray.push({
                                    "name": InHomeUtils.isNotEmpty(obj?.prodName) ?  obj?.prodName : '',
                                    "id": obj?.prodId,
                                    "merchCat": 'perk', 
                                    "category": obj?.prodType ,
                                    "offer": "",
                                    "qty": "1",
                                    "recurringPrice": obj?.price,
                                    "nonRecurringPrice": obj?.price,
                                    "line": "",
                                    "sku": "",
                                    "shippingCharge": "",
                                    "shippingType": "",
                                    "orderType": InHomeUtils.isNotNull(vzdl.txn) && InHomeUtils.isNotNull(vzdl.txn?.orderType) ? vzdl.txn?.orderType : "" ,
                                    ...(getMerchPropsFromMN())
                                })
                            })
                        });
                    }
                }
                //---
            })

        }
        else if (flowType === 'AF') {

            var cartProducts = tierPricing.tierContent;

            if (cartProducts != null && cartProducts.length > 0 && cartProducts[0].sections != null && cartProducts[0].sections.section != null) {
                let bundleProd = new Object();
                if (orderDetail.bundle == true) {
                    bundleProd.productNumber = orderDetail.bundleId;
                }

                cartProducts[0].sections.section.map((cartsections, index) => {
                    if (cartsections != null && cartsections.subSections != null && cartsections.subSections.subSection != null) {
                        cartsections.subSections.subSection.map((cartsubsection, index) => {
                            if (cartsubsection != null) {
                                if (orderDetail != null && orderDetail.bundle == true && cartsubsection.sectionType == 'SVCCOMPONENT') {
                                    bundleProd.productID = cartsubsection.title;
                                    bundleProd.primaryCategoryandSub = cartsubsection.sectionType;
                                    bundleProd.quantity = "1";
                                    bundleProd.priceDiscount = "0";
                                    bundleProd.priceRecurring = cartsubsection.sectionTotalprice;
                                    bundleProd.priceBase = cartsubsection.sectionTotalprice;
                                    bundleProd.type = cartsubsection.sectionType;
                                    prdArray.push(bundleProd);
                                }

                                if (cartsubsection.products != null) {
                                    cartsubsection.products.map((value, index) => {
                                        if (value.prodName != null) {
                                            let prod = new Object();
                                            if (value.prodType == "FVPRIMARY") {
                                                prod.productID = value.prodName.replace(/[^A-Za-z ]+/g, '');
                                            }
                                            else {
                                                prod.productID = value.prodName;
                                            }
                                            prod.productNumber = value.prodId;
                                            prod.primaryCategoryandSub = value.prodType;
                                            prod.quantity = "1";
                                            prod.priceDiscount = "0";
                                            if (value.priceType == "NRC") {
                                                prod.priceNonRecurring = value.price;
                                            } else {
                                                prod.priceRecurring = value.price;
                                            }
                                            prod.priceBase = value.price;
                                            prod.type = value.prodType;
                                            UpdateContractforRenewal(prod);
                                            prdArray.push(prod);
                                        }
                                    });
                                }

                                if (cartsubsection.promos != null) {
                                    cartsubsection.promos.map((value, index) => {
                                        let prod = new Object();
                                        prod.productID = value.promoText;
                                        prod.productNumber = value.promoId;
                                        prod.primaryCategoryandSub = value.offerAttrValue;
                                        prod.quantity = "1";
                                        if (value.price != null)
                                            prod.priceDiscount = value.price;
                                        else
                                            prod.priceDiscount = "0"
                                        prod.priceRecurring = "0";
                                        prod.priceBase = "0";
                                        prod.type = value.offerAttr;
                                        prdArray.push(prod);
                                    });
                                }
                                if (cartsubsection.promotions != null) {
                                    cartsubsection.promotions.map((value, index) => {
                                        if (value.OfferAttr && value.OfferAttr != "|NOTFORBACKEND|") {
                                            var prod = new Object();
                                            prod.productID = value.name;
                                            prod.productNumber = value.id;
                                            prod.primaryCategoryandSub = value.prodType;
                                            prod.quantity = "1";
                                            if (value.price != null)
                                                prod.priceDiscount = value.price;
                                            else
                                                prod.priceDiscount = "0"
                                            prod.priceRecurring = "0";
                                            prod.priceBase = "0";
                                            prod.type = value.OfferAttr;
                                            if (value.promotionId != null)
                                                prod.promoID = value.promotionId;
                                            if (value.offerId != null)
                                                prod.offerID = value.offerId;
                                            prdArray.push(prod);
                                        }
                                    });
                                }
                            }
                        });
                    }
                });

            }
        }
    }

    catch (error) {
        console.log(error)
    }

    if(prdArray.length === 0 && flowType === "MV"){
        return vzdl.txn.product.current
    }

    return prdArray;
}

const calcprdBasePrice = (product) => {
    let strprice = "0";
    // if (InHomeUtils.isNull(product.originalPrice)) {
    //     if (InHomeUtils.isNotNull(product.displayPrice))
    //         strprice = product.displayPrice.replace("$", "")
    // }
    if (InHomeUtils.isNotNull(product.displayPrice))
        strprice = product.displayPrice.replace("$", "")
    else {
        strprice = InHomeUtils.isNotNull(product.originalPrice) ? product.originalPrice : "" ;
    }
    return strprice;
}

const getMerchPropsFromMN = () => {
    const buildProduct = store && store.getState && store.getState().buildProduct;
    const selectedInternet = buildProduct && buildProduct.internet.selectedProduct;
    const selectedPerks = buildProduct?.perks?.selectedProduct?.length > 0 ? buildProduct?.perks?.selectedProduct : [];
    if(buildProduct?.isMNEnabled) {
        return {
            path: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'custom' : (buildProduct?.isPopularPlan ? 'popular' : 'recommended'),
           // merchPath: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'custom' : (buildProduct?.isPopularPlan ? 'popular' : 'recommended'),
            action: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'customized' : (buildProduct?.isPopularPlan ? 'preset' : 'modify'),
          //  merchAction: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'customized' : (buildProduct?.isPopularPlan ? 'preset' : 'modify')
        }
    } else {
        return {
            path: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'custom' : (buildProduct?.isPopularPlan ? 'popular' : 'recommended'),
         ///   merchPath: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'custom' : (buildProduct?.isPopularPlan ? 'popular' : 'recommended'),
            action: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'customized' : (buildProduct?.isPopularPlan ? 'preset' : 'modify'),
          //  merchAction: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'customized' : (buildProduct?.isPopularPlan ? 'preset' : 'modify')
        }
        /*return {
            merchCat: "",
            merchPath: "",
           // merchAction: ""
        };*/
    }
}

const getPrdArrayFromCart = (obj, flowType, offersTileData = []) => {
    let offerTile = "";
    offersTileData ?.forEach((res) => {
        if (res ?.id === obj ?.prodId) {
            offerTile = res ?.offerTileId;
        }
    })
    let prodCategoryType = (obj.prodName.indexOf("agreement") > -1 || obj.prodName.indexOf("contract") > -1) ? "AGREEMENT" :
    ((obj.prodTypeVal === "RSN") ? obj.prodType : prdCategoryInfo(obj.prodType, flowType, obj));
    let merchCategoryType = prodCategoryType?.indexOf('FTTP') != -1 ? 'plan' : prodCategoryType?.indexOf('BYOPERK') != -1 ? 'perk' : prodCategoryType?.indexOf('ROUTER') != -1 ? "accessories" : "";
    return ({
        // "productID": getPrdid(obj, flowType),
        // "discountID": "",
        // "productNumber": (obj.prodName.indexOf("agreement") > -1 || obj.prodName.indexOf("contract") > -1) ? "0" : obj.prodId,
        // "primaryCategoryandSub": (obj.prodName.indexOf("agreement") > -1 || obj.prodName.indexOf("contract") > -1) ? "AGREEMENT" :
        //     ((obj.prodTypeVal === "RSN") ? obj.prodType : prdCategoryInfo(obj.prodType, flowType, obj)),
        // "priceBase": obj.prodType === "MRCFEE" ? obj.bundleActucalPrice : (obj.price === "Included" ? "0" : (obj.price !== null ? obj.price.replace("$", "") : "0")),
        // "priceRecurring": obj.priceType !== null ? (obj.priceType === "NRC" ? "0" : (obj.price === "Included" ? "0" : obj.price.replace("$", ""))) : "0",
        // "priceDiscount": "0",
        // "quantity": "1",
        // "name": product.name,
        "name": getPrdid(obj, flowType),
        "id": (obj.prodName.indexOf("agreement") > -1 || obj.prodName.indexOf("contract") > -1) ? "" : obj.prodId,
        
        'merchCat': merchCategoryType,
        ...(merchCategoryType != '' && getMerchPropsFromMN()),
        "category": prodCategoryType,
        "offer": "",
        "discount": "",
        "qty": "1",
        "recurringPrice": obj.priceType !== null ? (obj.priceType === "NRC" ? "0" : (obj.price === "Included" ? "0" : obj.price.replace("$", ""))) : "0",
        "nonRecurringPrice": obj.priceType === "NRC" ? obj.bundleActucalPrice : obj.prodType === "MRCFEE" ? obj.bundleActucalPrice : (obj.price === "Included" ? "0" : (obj.price !== null ? "" : "0")),
        "line": "",
        "sku": "",
        "contractType": "",
        "shippingCharge": "",
        "shippingType": "",
        "shared": "",
        "orderType": InHomeUtils.isNotNull(vzdl.txn) && InHomeUtils.isNotNull(vzdl.txn.orderType) ? vzdl.txn.orderType : ""
    })


}

const UpdateContractforRenewal = (prod) => {
    try {
        if (prod != null) {
            if (prod.productID != null && prod.productID == '2 Year commitment') {
                prod.productID = 'TwoYears agreement plan';
                prod.primaryCategoryandSub = 'NewAgreement';
            }
        }
    }
    catch (e) {
    }

}
const getBundlecategory = (orderDetail) => {
    let srvcs = InHomeUtils.isNotNull(orderDetail.servicesOrdered) ? orderDetail.servicesOrdered.split(',') : "";
    let val = ""
    if (srvcs.length === 3) {
        val = "FVTB+FVIT+";
    }
    else if (InHomeUtils.isNotNull(orderDetail.servicesOrdered)) {
        if (orderDetail.servicesOrdered.indexOf("DATA") > -1 && orderDetail.servicesOrdered.indexOf("VIDEO") > -1) {
            val = "DFLX+FITN+"
        }
        else if (orderDetail.servicesOrdered.indexOf("DATA") > -1 && orderDetail.servicesOrdered.indexOf("FIOS_VOICE") > -1) {
            val = "FVDD+FVDN+"
        }
        else if (orderDetail.servicesOrdered.indexOf("VIDEO") > -1 && orderDetail.servicesOrdered.indexOf("FIOS_VOICE") > -1) {
            val = "FVTB+FVTN+"
        }
    }

    return val;
}

const getPrdid = (obj, flowType) => {
    let prdId = obj.prodName === "" ? obj.prodId : obj.prodName.replace(/&reg;/g, "").replace(/&amp;/g, "and");

    if (prdId === "DVR") {
        prdId = "DVR Service";
    }
    if (InHomeUtils.isNotNull(obj.prodTypeVal) && obj.prodTypeVal.indexOf("CUSTOM") > -1 && prdId.indexOf("Custom TV") === -1 && obj.prodTypeVal.indexOf("CUSTOMER_PROVIDED") === -1) {
        prdId = "Custom TV " + prdId;
    }

    if (flowType === "SUPP" && tempVzdlSCData.profileProduct.length > 0) {
        let isprofileprdMatch = false;
        for (var i = 0; i < tempVzdlSCData.profileProduct.length; i++) {
            if (tempVzdlSCData.profileProduct[i].prodId === obj.prodId) {
                isprofileprdMatch = true;
                break;
            }
        }
        if (!isprofileprdMatch) {
            tempVzdlSCData.profileProduct.map((tmpprofileObj) => {
                if (obj.prodId !== tmpprofileObj.prodId && obj.prodType === tmpprofileObj.prodType) {
                    switch (obj.prodType) {
                        case "BASIC":
                        case "VROOM":
                        case "VFEATURE":
                            prdId = "FVDO+ supp added-" + prdId + " FVDO+ supp deleted-" + tmpprofileObj.prodName;
                            break;
                        case "FTTPD":
                            prdId = "FTTP+ supp added-" + prdId + " FTTP+ supp deleted-" + tmpprofileObj.prodName;
                            break;
                        default:
                            break;
                    }

                }
                else if (obj.prodId !== tmpprofileObj.prodId && InHomeUtils.isNotNull(obj.prodType) && obj.prodType.indexOf("ROUTER") > -1
                    && InHomeUtils.isNotNull(tmpprofileObj.prodType) && tmpprofileObj.prodType.indexOf("ROUTER") > -1 && obj.prodType !== tmpprofileObj.prodType) {
                    prdId = "supp change router " + tmpprofileObj.prodName + " to supp " + prdId;
                }

            });
        }
    }

    if (flowType === "SUPP" && obj.prodType === "PREMIUM")
        prdId = "FVDO+ supp added- " + prdId;

    return prdId;
}

const addProductCurrent = (product, buildProduct) => {
    let prdArray = [];
    let flowType = store && store.getState && store.getState().app && store.getState().app.flowType;
    //const selectedInternet = buildProduct && buildProduct.internet.selectedProduct;
    //const selectedPerks = buildProduct?.perks?.selectedProduct?.length > 0 ? buildProduct?.perks?.selectedProduct : []
    if(InHomeUtils.isNotNull(product)){
        if (product.prodType === Service.flashOffer) {
            prdArray.push({
                "name": product.id,
                "id": "",
                "merchCat": "",
                "category": "DISCOUNT",
                "discount": product.OfferText,
                "qty": "1",
                "recurringPrice": "0",
                "nonRecurringPrice": "0",
                "line": "",
                "sku": "",
                "shippingCharge": "",
                "shippingType": "",
                "shared": "",
                "orderType": InHomeUtils.isNotNull(vzdl.txn) && InHomeUtils.isNotNull(vzdl.txn.orderType) ? vzdl.txn.orderType : ""
            })
        }
        else if(product.prodType === 'ApPaperFreeInternet'){
            prdArray.push({
                "name": "Auto-Pay and Paper Free Discount - Internet",
                "id": "Q7734",
                "merchCat": "",
                "category": "DISCOUNT",
                "discount": "Auto-Pay and Paper Free Discount - Internet",
                "qty": "1",
                "recurringPrice": "0",
                "nonRecurringPrice": "0",
                "line": "",
                "sku": "",
                "contractType": "MonthToMonth",
                "shippingCharge": "",
                "shippingType": "",
                "shared": "",
                "orderType": InHomeUtils.isNotNull(vzdl.txn) && InHomeUtils.isNotNull(vzdl.txn.orderType) ? vzdl.txn.orderType : ""
            })
        }
        else {
            let prodId = '';
            if (InHomeUtils.isNotNull(product.id))
                prodId = product.id;
            else if (InHomeUtils.isNotNull(product.prodId))
                prodId = product.prodId;

            let prodCategoryType = product?.productType ==='BYOPERK'? 'BYOPERK':  product.prodType === "PPP" ? getVasCategory(product) : prdCategoryInfo(product?.prodType, flowType, product);

            let merchCategoryType = prodCategoryType?.indexOf('FTTP') != -1 ? 
            'plan' : prodCategoryType?.indexOf('BYOPERK') != -1 ? 
            'perk'
            : prodCategoryType?.indexOf('ROUTER') != -1 ? "accessories" : "";
            prdArray.push({
                "name": getPrdName(product, flowType),
                "id": prodId,
                'merchCat': merchCategoryType, 
                "category": prodCategoryType,
                "discount": product.OfferText !== undefined ? product.OfferText : "",
                "qty": "1",
                "recurringPrice": ((InHomeUtils.isNotNull(product.prodType) && product.prodType.indexOf("NRC") > -1) || (InHomeUtils.isNotNull(product.keyword) && product.keyword.indexOf("FDV_BTRY_CHARGED") > -1)) ? "0" : calcprdBasePrice(product),
                "nonRecurringPrice": ((InHomeUtils.isNotNull(product.prodType) && product.prodType.indexOf("NRC") > -1))  ? calcprdBasePrice(product) : "",
                "line": "",
                "sku": "",
                "shippingCharge": "",
                "shippingType": "",
                "shared": "",
                "orderType": InHomeUtils.isNotNull(vzdl.txn) && InHomeUtils.isNotNull(vzdl.txn.orderType) ? vzdl.txn.orderType : "",
                ...(buildProduct?.isMNEnabled && merchCategoryType != '' && getMerchPropsFromMN())
            });
        } 
    }
    if(prdArray.length>0){
        if(!isProdView){
            // UPDATING product.current array based on selection // ITT-690346
            currProductsArray = vzdl.txn.product.current;
        }
        vzdl.txn.product.current = prdArray;
        isProdView = true;
    }
}

// Created for Datatrack links - tagging
export const dataTrack = (type, name) => {
    return JSON.stringify({
      type,
      name
    });
  }

export const updateThrottleValue = val => {
    if(val)
    {
        if(vzdl.page.throttle === '')
        vzdl.page.throttle = val;
        else if(vzdl.page.throttle.indexOf(val) !== -1)
            vzdl.target.throttle = vzdl.target.throttle;
        else 
        vzdl.page.throttle = vzdl.page.throttle+ '| '+ val;
    }
}

export const updateThrottleValueSLO = () =>{
    const throttleList = InHomeUtils.getCookie('cdlThrottleList', document.cookie) 
    if( throttleList !== null && throttleList !== ""){
        vzdl.target.sandbox = throttleList
        if((throttleList.includes("LQSO_T_Streamline_P") || throttleList.includes("LQSO_T_Streamline_L")) && window.location.pathname === '/inhome/streamlinetvvoice'){
            vzdl.page.throttle = 'so_y|pred_y';
            vzdl.page.name = "Streamline Buildproducts - TV & Phone";

        }
        else if(throttleList.includes("LQSO_T_Streamline_P") || throttleList.includes("LQSO_T_Streamline_L")){
            vzdl.page.throttle = 'so_y|pred_y';
            if(window.location.pathname === '/inhome/streamlineordering'){
                vzdl.page.name = 'Streamline Buildproducts - Internet & Perks';
            }
        }
        else if(throttleList.includes("LQSO_C_Streamline_P") || throttleList.includes("LQSO_C_Streamline_L")){
            vzdl.page.throttle = 'so_n|pred_n';
        }
    }
    
}

export const updateCartIDValue = (params) => {
    if (params) {
        vzdl.txn.cartId = params;
    }
}

export const updateDetailValue = val => {
    if(val)
    {
        vzdl.page.detail = val;
    }
    else if(!val)
    {
        vzdl.page.detail = '';
    }
}

const updatePendingDisconnectSubFlow = (stateInfo) => {
    
    let fullDisconnectAddress = (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo.lqQualdetails) && InHomeUtils.isNotNull(stateInfo.lqInfo.lqQualdetails.getAdditionalInfo) && stateInfo?.lqInfo?.lqQualdetails?.getAdditionalInfo?.pendingOrderDisconnect) ? 'Pending Disconnect' : '';
//Checking for full disconnect
if(vzdl.page.subFlow === ""){
    if(fullDisconnectAddress){
        vzdl.page.subFlow = "Pending Disconnect"
    }          
}else if(fullDisconnectAddress && vzdl.page.subFlow.indexOf(fullDisconnectAddress) === -1){
    vzdl.page.subFlow = vzdl.page.subFlow + " | Pending Disconnect";
}

}

export const updateSubFlowValue = (val, excludeVal = '') => {
   
 
    if(val)
    {
        if(excludeVal !== ''){
            if(!(vzdl.page.subFlow.toLowerCase().includes(excludeVal))){
                vzdl.page.subFlow = vzdl.page.subFlow + val;
            }
        }
        else{
            vzdl.page.subFlow = vzdl.page.subFlow + val;
        }
    }    
}

export const updateMessageValue = (messagevalue="") => {
    vzdl.target.message = messagevalue?messagevalue :"";    
    targetMessageFlag = messagevalue ? true : targetMessageFlag;
}

export const updatePageValue = (pagename="") => {
    vzdl.page.name = pagename?pagename :"";    
}

export const updateSandboxIdValue = (val = "", excludeVal = '') => {
    if(val)
    {
        if(vzdl.target.sandbox === '')
        vzdl.target.sandbox = val;
        else if(vzdl.target.sandbox.indexOf(val) !== -1)
            vzdl.target.sandbox = vzdl.target.sandbox;
        else {
            if(excludeVal && vzdl.target.sandbox.includes(excludeVal)){
                vzdl.target.sandbox = vzdl.target.sandbox.replace(excludeVal, val)
            }
            else{
                vzdl.target.sandbox = vzdl.target.sandbox+ '| '+ val;
            }
            

        }
        
    } 
}

export const updateOrderLocation = (orderLoc) => {
    if (orderLoc) {
        vzdl.txn.outletId = orderLoc;
    }
}

export const populatelqStateValue = (lqState) => {
    const productsQualifiedArr = [];
    let productsQualified = '';
    try {
        productsQualified = 'nc-single-';
        const srvcs = lqState;
        if (srvcs) {
            for (let i = 0; i < srvcs.length; i++) {
            if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'FiOSData') {
                productsQualified += 'fdata';
            } else if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'Video') {
                productsQualified += productsQualified !== 'single-' ? '+ftv' : 'ftv';
                productsQualified = productsQualified.replace('single', 'double');
            } else if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'Voice') {
                productsQualified += productsQualified !== 'double-' || productsQualified !== 'single' ? '+fphone' : 'fphone';
                productsQualified =
                productsQualified.indexOf('single') > -1
                    ? productsQualified.replace('single', 'double')
                    : productsQualified.replace('double', 'triple');
            }
            }
        }
        let type = 'single';
        if (productsQualified.indexOf('double') > -1) {
            type = 'double';
        } else if (productsQualified.indexOf('triple') > -1) {
            type = 'triple';
        }
        productsQualifiedArr.push("fios", type);
        if (productsQualified.indexOf('fdata') > -1) {
            productsQualifiedArr.push('fdata');
        }
        if (productsQualified.indexOf('fphone') > -1) {
            productsQualifiedArr.push('fphone');
        }
        if (productsQualified.indexOf('ftv') > -1) {
            productsQualifiedArr.push('ftv');
        }
        return productsQualifiedArr;
    } catch (e) {
      console.log('populatelqStateValue');
    }
}

export const loopQualVzTaglqs = async (addressId = '', lqResult = [], zipCode = '', addressEmail = '', phoneNumber = '', isMnhFlow = false, ispendingOrderDisconnect) => {
    let hashedAddressIdVal = '';
    let locusId = '';
    // let response = window.sessionStorage.getItem('LQResponse'); 
    // var responseObj = JSON.parse(response);
    // let sequentialFiosComboOrder = responseObj?.data?.qualificationDetails?.data?.isSequentialFiosComboOrder
    let response = window.sessionStorage.getItem('comboResponseObj');
    let responseObj = JSON.parse(response)
    let sequentialFiosComboOrder = responseObj?.sequentialFiosComboOrder
    if (InHomeUtils.isNotEmpty(response)) {
        if(responseObj && responseObj.output){
            if(InHomeUtils.isNotEmpty(responseObj.output.hashedLocusId)) {
                hashedAddressIdVal = responseObj.output.hashedLocusId
            }
            if (responseObj.output.addressId) {
                locusId = InHomeUtils.isNotEmpty(responseObj.output.addressId) ? responseObj.output.addressId : locusId;
                addressId = locusId && locusId !== '' ? locusId : addressId;
            }
            else if(responseObj.output.subLocationId){
                locusId = InHomeUtils.isNotEmpty(responseObj.output.subLocationId) ? responseObj.output.subLocationId : locusId;
                addressId = locusId && locusId !== '' ? locusId : addressId;
            }
            else if (addressId === '' && responseObj.output.fiosResponse && responseObj.output.fiosResponse.postValues && responseObj.output.fiosResponse.postValues.config && responseObj.output.fiosResponse.postValues.config.addressInfo
                && (responseObj.output.fiosResponse.postValues.config.addressInfo.addressid || responseObj.output.fiosResponse.postValues.config.addressInfo.addressId) && (InHomeUtils.isNotEmpty(responseObj.output.fiosResponse.postValues.config.addressInfo.addressid) || InHomeUtils.isNotEmpty(responseObj.output.fiosResponse.postValues.config.addressInfo.addressId))) {
                addressId = responseObj.output.fiosResponse.postValues.config.addressInfo.addressid ? responseObj.output.fiosResponse.postValues.config.addressInfo.addressid : responseObj.output.fiosResponse.postValues.config.addressInfo.addressId;
            }
        }
    }
    if(hashedAddressIdVal === '' && addressId !== ''){
        const keyValue = (addressId + shaKey);
        try {
            const msgUint8 = new TextEncoder().encode(keyValue);                         
            const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);          
            const hashArray = Array.from(new Uint8Array(hashBuffer));                   
            hashedAddressIdVal = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        }
        catch (error) {
            console.error("getSHA-256 failed", error);
        }
    }
    const throttleList =InHomeUtils.getCookie('cdlThrottleList') || window.sessionStorage.getItem('LqThrottle') ? window.sessionStorage.getItem('LqThrottle') : '';
    let subFlowVal='byob';
    const autoLocationPromptGeo = window.sessionStorage.getItem('autoLocationPromptGeo') 
    if (autoLocationPromptGeo) {
        subFlowVal += '|prompt geo';
    }
    if(sequentialFiosComboOrder){
        subFlowVal += '| Seq mh';
    }
    if(ispendingOrderDisconnect){
        subFlowVal += '| pending disconnect';
    }
    if (window.sessionStorage.getItem('fiosMduBaseID')) {
        subFlowVal += '| ntasId-N';
    }
    const dataObject = {
        version: 2,
        type: 'lqs',
        zip: zipCode,
        hashedAddress: hashedAddressIdVal,
        errorMessage: '',
        detail: ispendingOrderDisconnect ? 'lq result - fios eligible | pending disconnect' : 'lq result - fios eligible',
        eligible: populatelqStateValue(lqResult),
        data: {
          page: {
            flow: 'lq widget',
            throttle: 'nsa version|vhi home|passive-lq|geo|mhnewsignin|suppresslqa|fiosehp_y|', 
            zip: zipCode,
            LQZip: zipCode,
            channel: 'Ordering',
            displayChannel: 'VZF',
            sourceChannel: 'VZF',
            channelSession: window.sessionStorage.getItem('visit_id'),
            applicationName: InHomeUtils.getdeviceType(),
            subFlow: subFlowVal,  
            subCategory: window.sessionStorage.getItem('lq4') ? 'LQ 4.0' : 'LQ 3.0',
            name:'buildproducts',
          },
          user: {
            authStatus: (InHomeUtils.getCookie('loggedIn') || InHomeUtils.getCookie('userinfo'))? 'logged in' :'anonymous',
            accountType: (InHomeUtils.getCookie('loggedIn') || InHomeUtils.getCookie('userinfo'))? 'existing customer' :'new customer',
            session:window.sessionStorage.getItem('visitor_id'),
            zip: zipCode,
          },
          target: {
            offer: '',
            engagement: {
              intent: 'Ordering',
            },
            message: '',
            sandBox: throttleList, 
          },
          utils: {
            rtm: {
              locusId: locusId,
              prospectEmail: addressEmail,
              mtn: phoneNumber,
            },
          },
          env: {
            businessUnit: "Wireline",
        },
        },
        discount_mh_ec: false,
        discount_mh_nc: isMnhFlow,
    }
    window.vzdl = dataObject.data;
    if (window.VZTAG_IS_READY) {
        window.vztag.api.dispatch('loopQual', dataObject);
      } else {
        document.addEventListener(
          'vztagReady',
          (function vztagApi(VapiName, Vobj) {
            return () => {
              window.vztag.api.dispatch(VapiName, Vobj);
            };
          })('loopQual', dataObject),
        );
      }
}

export const passiveVzTagLqs = async (lqResult) =>{
  let zip_Code = '';
  let subFlow = '';
  let bulkQual_AddressType = '';
  const response = window.sessionStorage.getItem('LQResponse');
  if (response) {
    const responseObj = JSON.parse(response);
    if (responseObj && responseObj.output) {
      const { zipCode, bulkQualAddressType } = responseObj.output || {};
      zip_Code = zipCode;
      bulkQual_AddressType = bulkQualAddressType;
    }
  }
  const throttleList = InHomeUtils.getCookie('cdlThrottleList') || window.sessionStorage.getItem('LqThrottle') ? window.sessionStorage.getItem('LqThrottle') : '';
  const event = bulkQual_AddressType === 'BillAccount' ? 'event337' : 'event338';
  subFlow = bulkQual_AddressType === 'GEO_LOCATION' ? 'plqs-geo' : '';
  const dataObject = {
    name: 'passive lq',
    data: {
      page: {
        flow: 'lq widget',
        subFlow: subFlow,
        throttle: 'nsa version|vhi home',
        channel: 'Ordering',
        zip: zip_Code,
        LQZip: zip_Code,
        detail: 'plq result -single fios eligible',
        channelSession: window.sessionStorage.getItem('visit_id'),
        applicationName: InHomeUtils.getdeviceType(),
        displayChannel: 'VZF',
        sourceChannel: 'VZF',
        subCategory: window.sessionStorage.getItem('lq4') ? 'LQ 4.0' : 'LQ 3.0',
        name: 'buildproducts',
      },
      user: {
        user: {
            authStatus: (InHomeUtils.getCookie('loggedIn') || InHomeUtils.getCookie('userinfo'))? 'logged in' :'anonymous',
            accountType: (InHomeUtils.getCookie('loggedIn') || InHomeUtils.getCookie('userinfo'))? 'existing customer' :'new customer',
            session:window.sessionStorage.getItem('visitor_id'),
            productsQualified:populatingStateValues(lqResult),
            zip: zip_Code,
          },
      },
      event: {
        value: `event334,${event}`,
      },
      target: {
        engagement: {
          intent: 'Ordering',
        },
        sandBox: throttleList,
      },
      env: {
        businessUnit: "Wireline",
    },
    },
  };
  window.vzdl = dataObject.data;
  if (window.VZTAG_IS_READY) {
    window.vztag.api.dispatch('sendData', dataObject);
  } else {
    document.addEventListener(
      'vztagReady',
      (function vztagApi(VapiName, Vobj) {
        return () => {
          window.vztag.api.dispatch(VapiName, Vobj);
        };
      })('sendData', dataObject),
    );
  }
}

export const setProductsCurrent = (orderDetails, cartResponseVal, flowtype = "", eventsVal = "") => {
    if(vzdl){
        if(eventsVal && eventsVal !== "" && vzdl.event){
            vzdl.event.value =  eventsVal;
        }
        if(vzdl.txn && vzdl.txn.product){
            vzdl.txn.product.current = getProductObject(orderDetails, cartResponseVal, flowtype);
        }
    }
}

